import Print from '@mui/icons-material/Print'
import CalendarToday from '@mui/icons-material/CalendarToday'
import AttachMoney from '@mui/icons-material/AttachMoney'
import { default as BadgeIcon } from '@mui/icons-material/Badge'
import Psychology from '@mui/icons-material/Psychology'
import Assignment from '@mui/icons-material/Assignment'
import Warning from '@mui/icons-material/Warning'
import Healing from '@mui/icons-material/Healing'
import LocalPharmacy from '@mui/icons-material/LocalPharmacy'
import Science from '@mui/icons-material/Science'
import TipsAndUpdates from '@mui/icons-material/TipsAndUpdates'
import MenuBook from '@mui/icons-material/MenuBook'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Popover,
  TextareaAutosize,
  Box,
  Typography,
  Chip,
  Card,
  CardContent,
  Tooltip,
  Drawer,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from '@mui/material'
import Close from '@mui/icons-material/Close'
import History from '@mui/icons-material/History'
import Medication from '@mui/icons-material/Medication'
import MonitorHeart from '@mui/icons-material/MonitorHeart'
import Download from '@mui/icons-material/Download'
import WhatsApp from '@mui/icons-material/WhatsApp'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import MenuIcon from '@mui/icons-material/Menu'
import dayjs from 'dayjs'
import React, {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { ActiveStaffMarqueeComponent } from 'src/clinic/components/ClinicManageBookingsPage/ActiveStaffMarqueeComponent'
import { getPatientVitalForBookedEvent } from 'src/clinic/components/ClinicManageBookingsPage/utils'
import { VitalsComponentInlineEntryComponent } from 'src/clinic/components/ClinicManageBookingsPage/VitalsComponentInlineEntryComponent'
import InvestigationForm from 'src/clinic/components/InvestigationsForm/InvestigationsForm'
import { selectPrescriptionViewSettingsData } from 'src/clinic/reducers/prescription/prescriptionReducer'
import { fetchDrugAdviceEntity } from 'src/clinic/reducers/prescription/services/drugAdviceItems'
import { fetchEmrSections } from 'src/clinic/reducers/prescription/services/emrSectionThunk'
import { fetchPrescriptionViewSettings } from 'src/clinic/reducers/prescription/services/prescriptionViewSettingsThunk'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import {
  GENDER_LIST_ONBOARDING,
  HE_DRUG_ADVICE_DOSAGE,
  HE_DRUG_ADVICE_DURATION,
  HE_DRUG_ADVICE_FREQUENCY,
  HE_DRUG_ADVICE_NOTE,
  HE_DRUG_ADVICE_TIMING,
  HE_DRUG_ADVICE_TYPE,
  HE_KEY_ADVICE,
  HE_KEY_DIAGNOSIS,
  HE_KEY_DRUGS,
  HE_KEY_HEALTH_COMPLAINTS,
  HE_KEY_INSTRUCTIONS,
  HE_KEY_INVESTIGATION,
  HE_KEY_OBSERVATIONS,
  HE_KEY_PSYCH_ASSESSMENTS,
  PRESCRIPTION_BUILDER_VIEW_TYPES,
  A4DpiToDetailsMap,
} from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import {
  convertAssessmentIdBasedCategoryListToMetaCategoryList,
  getOrdinalSuffix,
  removeKeyFromObject,
} from 'src/consumer/helpers/utilFunctions'
import {
  selectCategoriesList,
  setCategoriesList,
} from 'src/consumer/reducers/genericData/genericDataReducer'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { DocSideContext } from 'src/context/DocSideContextProvider'
import { useCheckedInOrPeekedInChamberRoomId, useScreenSize } from 'src/customHooks/customHooks'
import JointHomunculusComponent from 'src/emr/components/swollenJointHighlighter/SwollenJointHighlighter'
import { isAppRunningInProduction } from 'src/helper'
import useEmrSectionsData from 'src/mentor/components/EmrRelatedComponents/hooks/useEmrSectionsData'
// TRIGGER_SAVE_COMPLETED reserved for future use
import PatientVisitSummaryHandler from 'src/mentor/components/commonReportComponents/components/consultationSummary/PatientVisitSummaryHandler'
import EMRNextVisitComponent from 'src/mentor/components/commonReportComponents/components/nextVisit/prescriptionMakingPageComponents/EMRNextVisitComponent'
import useEmrSectionsEditorDialog from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/hooks/useEmrSectionsEditorDialog'
import usePrescriptionViewSettingsForRx from 'src/mentor/components/PrescriptionMakingPage/viewOnlyComponents/hooks/usePrescriptionViewSettingsForRx'
import ViewOnlyPrescriptionV2 from 'src/mentor/components/PrescriptionMakingPage/viewOnlyComponents/ViewOnlyPrescriptionV2'
import usePrescriptionDataForTemplate from 'src/mentor/components/MentorPrescriptionTemplates/components/hooks/usePrescriptionDataForTemplate'
import { selectEmrSectionsData } from 'src/clinic/reducers/prescription/prescriptionReducer'
import {
  getDataMapFromCommonResponse,
  getErrorResponseFromErrorResponse,
  getPriceStringWithCurrency,
  isCommonResponseSuccessful,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { getMPDataWithParams, postMPDataWithoutParams } from 'src/mentor/services'
import { selectDoctorRecommendedHealthEntities } from 'src/reducers/doctorRecommendedHealthEntities/doctorRecommendedHealthEntitiesReducer'
import { getDoctorRecommendedHealthEntities } from 'src/reducers/doctorRecommendedHealthEntities/services/doctorRecommendedHealthEntities'
import useEmrSections from '../EmrRelatedComponents/hooks/useEmrSections'
import EmrSectionsEditorDialog from './components/EmrSectionsEditorDialog'
import PrivateNotesSection from './components/PrivateNotesSection'
import { PrescriptionDataContext } from './context/PrescriptionDataProvider'
import useDrugAdviceData from './hooks/useDrugAdviceData'
import useInvestigationData from './hooks/useInvestigationData'
import useMentorProfileData from './hooks/useMentorProfileData'
import usePagedPrintHistory from './hooks/usePagedPrintHistory'
import useScreeningReportData from './hooks/useScreeningReportData'
import usePrintActions from './hooks/usePrintActions.jsx'
import AdviceInputComponent from './inputComponents/advice/AdviceInput'
import HealthComplaintsInputComponent from './inputComponents/complaints/HealthComplaintsInputComponent'
import DiagnosisSelectMenu from './inputComponents/diagnosis/DiagnosisMenu'
import { isDiagnosisSectionIsATable } from './inputComponents/diagnosis/util'
import DrugAdviceInput from './inputComponents/drugAdvice/DrugAdviceInput'
import EMRInstructionsInput from './inputComponents/instructions/EMRInstructionsInput'
import { InvestigationsSelectMenu } from './inputComponents/investigation/InvestigationInputComponent'
import ObservationsInputComponent from './inputComponents/observations/HealthObservationsInputComponent'
import TopPatientDetailsHeading from './layoutComponents/TopPatientDetailsHeading'
import {
  renderSectionForDocon as _renderSectionForDoconImported,
  renderSectionForHP as _renderSectionForHPImported,
} from './layoutComponents/SectionDispatcher'
import {
  keepSectionStateBeforeClearAll,
  undoClearAllChangeInPrescription,
} from './prescriptionHelperFunctions'
import {
  AddNewTestComponent,
  AutoFillFromLastPrescriptionComponent,
  CancelAndRedoComponent,
  getDateOfPrescription,
  getDrugsListArrayForSubmission,
  getHealthEntityArrayForSubmission,
  getInitialDataForSettingDaysOfNextVisit,
  getInitialDataForSettingExistingDrugAdvice,
  getInitialDataForSettingExistingHealthEntity,
  getInitialDataForSettingExistingSelectedTherapies,
  getInitialDataForSettingSelectedTherapist,
  getNextVisitDateForSubmission,
  getSelectedTherapiesArrayForSubmission,
  handleAddDrugAdviceItem,
  handleDeleteDrugAdviceItem,
  handleDrugAdviceChange,
  saveNewDrugs,
  saveNewHealthEntityList,
  SuggestedAssessmentsSelectMenu,
  SuggestedTherapySelectMenu,
} from './PrescriptionMakingPageComponents'
import {
  DoconPageItemsContainer,
  DoconPageSingleItemContainer,
  PMPSectionHeading,
  PMPSectionInputBox,
  PrescriptionTabFinalParent,
  SectionSecondaryHeadingAndContent,
} from './PrescriptionMakingPageStyles'
import {
  formNewInternalDrugObjectWithDrugAdviceItems,
  getDrugAdviceItems,
  isHomunculusValid,
} from './utils'
import { createPrescriptionSectionRenderers } from './sectionRenderers'
import { generateClientSidePDFForPrint as _generateClientSidePDFForPrint } from './printComponents/pdfGenerationEngine'
import PrescriptionViewWithPrintCSS from './printComponents/PrescriptionViewWithPrintCSS'
import LSPastVisitReportsComponent from 'src/consumer/components/LiveSessionPage/components/LSPastVisitReportsComponent/LSPastVisitReportsComponent'
import EmrActionDialog from 'src/mentor/components/EmrRelatedComponents/components/EmrActionDialog'
import { handleGuardDialogResponse } from 'src/mentor/components/EmrRelatedComponents/utils/emrGuardChecker'
import {
  getFreeFormRichTextFromEmrSectionDataList,
  mergeFreeFormRichTextIntoEmrSectionDataList,
} from 'src/mentor/components/EmrRelatedComponents/FreeFormRichText/freeFormRichTextUtils'
import SignatureComponent from './prescriptionTemplate/body/SignatureComponent'

// Print button component for section headers - extracted outside to prevent recreation on every render
// Read-only print indicator - shows whether section will print on prescription
const SectionPrintIndicator = React.memo(({ sectionId, emrSectionsToShowInOrder }) => {
  const section = useMemo(
    () => emrSectionsToShowInOrder?.find((item) => item?.id === sectionId),
    [emrSectionsToShowInOrder, sectionId],
  )
  const isPrintable = section?.printable

  const tooltipTitle = useMemo(
    () =>
      isPrintable
        ? 'Included in printed prescription'
        : 'Not included in printed prescription',
    [isPrintable],
  )

  if (!isPrintable) {
    return null // Don't show anything if not printable
  }

  return (
    <Tooltip title={tooltipTitle} arrow placement="top">
      <Chip
        icon={<Print sx={{ fontSize: '16px' }} />}
        label="On Rx"
        size="small"
        sx={{
          backgroundColor: 'rgba(16, 185, 129, 0.1)',
          color: '#059669',
          border: '1px solid rgba(16, 185, 129, 0.3)',
          fontWeight: 600,
          fontSize: '11px',
          height: '24px',
          '& .MuiChip-icon': {
            color: '#059669',
          },
        }}
      />
    </Tooltip>
  )
}, (prevProps, nextProps) => {
  if (prevProps.sectionId !== nextProps.sectionId) {
    return false
  }
  
  const prevSection = prevProps.emrSectionsToShowInOrder?.find((item) => item?.id === prevProps.sectionId)
  const nextSection = nextProps.emrSectionsToShowInOrder?.find((item) => item?.id === nextProps.sectionId)
  const prevPrintable = prevSection?.printable ?? false
  const nextPrintable = nextSection?.printable ?? false
  
  return prevPrintable === nextPrintable
})

SectionPrintIndicator.displayName = 'SectionPrintIndicator'

const PrescriptionMakingPage = forwardRef(
  (
    {
      propEventId,
      propPatientId,
      propClinicId,
      propClinicBrandId,
      propMentorProfileData,
      honorPropValue,
      propValue,
      setPropValue,
      propBookedEventInfo,
      triggerSave: _triggerSave,
      setTriggerSave: _setTriggerSave,
      afterSaveFunction: _afterSaveFunction,
      auxiliaryDataFromProps,
      getProcessAndSetEventData,
      showPatientDetailsInHeader: _showPatientDetailsInHeader,
      moveToPrintPrescriptionScreen,
      setMoveToPrintPrescriptionScreen,
      inChamber = false,
      onRxPrint, // Callback to open Rx drawer and trigger PRINT ALL
    },
    componentRef,
  ) => {
    const historySectionRef = useRef(null)
    // Tracks the last meaningful setup key so setup() only re-runs when eventId/patientId
    // changes OR when auxiliaryDataFromProps first transitions from null to non-null.
    // Prevents repeated API calls when the parent calls setAuxiliaryData() with new object
    // references that have identical content.
    const _setupKeyRef = useRef(null)


    // Mentor profile data hook
    const { mentorProfileData, mentorProfileDataLoading, refreshMentorProfile } =
      useMentorProfileData(propMentorProfileData)
    const [prescriptionId, setPrescriptionId] = useState(null)
    // const targetRef = useRef()
    const urlParams = new URLSearchParams(window.location.search)
    const eventId = propEventId || urlParams.get('eventId')
    const patientId = propPatientId || urlParams.get('patientId')
    const clinicId = propClinicId || urlParams.get('clinicId')
    const clinicBrandId = propClinicBrandId
    const [prescriptionSaveLoading, setPrescriptionSaveLoading] = useState(false)
    const [bookedEventInfo, setBookedEventInfo] = useState(propBookedEventInfo)

    // const [drugAdviceTypes, setDrugAdviceTypes] = useState()

    const [value, setValue] = useState('')
    const [_placeholder, setPlaceholder] = useState('')

    const [newTestAnchor, setNewTestAnchor] = useState(null)

    const [freeFormRichText, setFreeFormRichText] = useState('')

    const DEBUG_MODE = localStorage.getItem('debugMode') === 'true'

    // const [emrSections, setEmrSections] = useState([])
    // const [loadingEmrSections, setLoadingEmrSections] = useState(true)

    const prescrpitionViewSettingsStoreData = useSelector(selectPrescriptionViewSettingsData)

    // Investigation data hook
    const {
      sampleTypes,
      investigationToEdit,
      showInvestigationForm,
      savingInvestigation,
      investigationTitleValid,
      confirmationModalProps,
      initialInvestigationObjectToEdit,
      setConfirmationModalProps: _setConfirmationModalProps,
      openInvestigationForm,
      setInvestigationToEdit,
      setSavingInvestigation,
      setInvestigationTitleValid,
      closeInvestigationForm,
      handleChangeInvestigationToEdit,
      saveInvestigation: _saveInvestigation,
      submitInvestigation,
      getInvestigationSamples,
    } = useInvestigationData(clinicId, clinicBrandId)

    // Drug advice data hook
    const {
      drugAdviceDosages,
      drugAdviceNotes,
      drugAdviceDurations,
      drugAdviceFrequencies,
      drugAdviceWhatTimeOptions,
      drugAdviceTypes,
      fetchAllDrugAdviceData: _fetchAllDrugAdviceData,
    } = useDrugAdviceData(clinicBrandId)
    const [_loadingPrescriptionData, setLoadingPrescriptionData] = useState(false)

    const roomId = useCheckedInOrPeekedInChamberRoomId()

    const {
      prescriptionData,
      setPrescriptionData,

      printType,
      setPrintType,

      drugsAdvice,
      setDrugsAdvice,
      selectedComplaints,
      setSelectedComplaints,
      selectedDiagnosis,
      setSelectedDiagnosis,
      selectedInvestigations,
      setSelectedInvestigations,
      selectedObservations,
      setSelectedObservations,
      selectedAdvice,
      setSelectedAdvice,
      selectedInstructions,
      setSelectedInstructions,
      jointHomunculusData,
      setJointHomunculusData,
      nextVisitInputValue,
      setNextVisitInputValue,

      nextVisitInputType,
      setNextVisitInputType,
      selectedTherapies,
      setSelectedTherapies,
      selectedTherapist,
      setSelectedTherapist,
      discountedPriceOfSession,
      setDiscountedPriceOfSession,
      priceUpdateLoading,
      setPriceUpdateLoading,
      choseToGiveDiscount,
      setChoseToGiveDiscount,
      suggestedBookingTherapy,
      setSuggestedBookingTherapy,
      allVitalsOfThisPatient,
      setAllVitalsOfThisPatient,
      selectedAssessments,
      setSelectedAssessments,
      finalRequestedTestsBy,
      setFinalRequestedTestsBy,

      referredToDoctorName,
      setReferredToDoctorName,

      notesToTherapist,
      setNotesToTherapist,
      attachPrescriptionForTherapy,
      setAttachPrescriptionForTherapy,

      notesForAssessments,
      setNotesForAssessments,
      attachPrescriptionForAssessments,
      setAttachPrescriptionForAssessments,

      patientHistoryNotes,
      setPatientHistoryNotes,
    } = useContext(PrescriptionDataContext)
    const { width: screenWidth, height: screenHeight } = useScreenSize()
    const { setFlowId: _setFlowId, setButtonTopOffset, setShowDocSide } = useContext(DocSideContext)

    const doctorPrescriptionViewSettings = useMemo(() => {
      const settings = prescrpitionViewSettingsStoreData?.data || {
        prescriptionBuilderViewType: PRESCRIPTION_BUILDER_VIEW_TYPES.minimal,
        preferredPrescriptionLanguages: ['en'],
      }
      
      return settings
    }, [prescrpitionViewSettingsStoreData])

    const prescriptionViewSettings = useMemo(() => {
      let toReturn = { ...doctorPrescriptionViewSettings } // Create a copy to avoid mutations
      if (screenWidth <= screenHeight && screenWidth < 1200) {
        toReturn = {
          ...toReturn,
          prescriptionBuilderViewType:
            toReturn?.prescriptionBuilderViewType === PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView
              ? PRESCRIPTION_BUILDER_VIEW_TYPES.modern
              : toReturn?.prescriptionBuilderViewType,
        }
      }
      
      return toReturn
    }, [doctorPrescriptionViewSettings, screenWidth, screenHeight])

    const recommendedHEData = useSelector(selectDoctorRecommendedHealthEntities)
    const recommendedHealthEntityForDoctor = recommendedHEData?.data

    // const [recommendedHealthEntityForDoctor, setRecommendedHealthEntityForDoctor] = useState()

    const [currentPageHistory, setCurrentPageHistory] = useState([])

    // Screening report data hook
    const {
      screeningReportData,
      screeningReportVisible,
      screeningSections,
      screeningReportTemplateData,
      setScreeningReportVisible,
      setScreeningReportData,
      setScreeningData: _setScreeningData,
      getScreeningSections,
      getAndSetScreeningData,
    } = useScreeningReportData(clinicBrandId, bookedEventInfo)

    const {
      open: emrSectionsEditorDialogOpen,
      handleOpen: emrSectionsEditorDialogHandleOpen,
      handleClose: emrSectionsEditorDialogHandleClose,
    } = useEmrSectionsEditorDialog()

    // EMR sections hook
    const {
      emrSections,
      setEmrSections: _setEmrSections,
      updateEmrSectionPrintStatus: _updateEmrSectionPrintStatus,
      loadingEmrSections,
      emrSectionsToShowInOrder,
      emrSectionsToShowInOrderForDocOn,
      currentPage,
      onPrescriptionPreviewPage: _onPrescriptionPreviewPage,
      getEmrSections: _getEmrSections,
      saveEmrSections: _saveEmrSections,
      refreshEmrSections,
      showNextVisitSlotSelector,
      setShowNextVisitSlotSelector,
    } = useEmrSections(currentPageHistory, 'prescription')

    const {
      emrSectionDataList,
      patientHistoryEmrData,
      setPatientHistoryEmrData,
      setEmrSectionDataList,
    } = useEmrSectionsData({ emrSections })

    // Always include screening report section when screeningReportData exists, regardless of EMR settings
    const emrSectionsToShowInOrderWithScreening = useMemo(() => {
      const sections = [...(emrSectionsToShowInOrder || [])]
      
      // Check if screening report section already exists
      // Note: The section ID must be 'screening-report' to match the switch case in renderSectionForHP
      const existingScreeningIndex = sections.findIndex(
        (section) => section?.id === 'screening-report' || section?.id === 'screeningReportData'
      )
      
      // If screeningReportData exists, ensure the section is included and enabled
      if (screeningReportData) {
        if (existingScreeningIndex !== -1) {
          // Section exists - force it to be enabled and selected, and ensure correct ID
          sections[existingScreeningIndex] = {
            ...sections[existingScreeningIndex],
            id: 'screening-report', // Ensure correct ID
            selected: true,
            enabled: true,
          }
        } else {
          // Section doesn't exist - add it with correct ID
          sections.push({
            id: 'screening-report', // Must match the switch case in renderSectionForHP
            title: 'Screening Report',
            selected: true,
            enabled: true,
            defCode: 'screeningReportData',
          })
        }
      }
      
      return sections
    }, [emrSectionsToShowInOrder, screeningReportData])

    const hasEnabledPatientVitalsSection = useMemo(
      () =>
        emrSectionsToShowInOrderWithScreening?.some(
          (section) =>
            section?.enabled &&
            (section?.id === 'patient-vitals' || section?.defCode === 'patient-vitals'),
        ) || false,
      [emrSectionsToShowInOrderWithScreening],
    )

    const currentBookedEventVital = useMemo(() => {
      const bookedEventId = bookedEventInfo?.id || eventId
      if (!bookedEventId || !Array.isArray(allVitalsOfThisPatient)) return null
      return allVitalsOfThisPatient.find((item) => item?.bookedEventId === bookedEventId) || null
    }, [allVitalsOfThisPatient, bookedEventInfo?.id, eventId])

    const [isPrintingPastHistoryReports, setIsPrintingPastHistoryReports] = useState(false)
    const [_selectedPagesForPrint, _setSelectedPagesForPrint] = useState([])
    const [totalPages, setTotalPages] = useState(0)
    const [pdfDrawerOpen, setPdfDrawerOpen] = useState(false)
    const [quickPrintDrawerOpen, setQuickPrintDrawerOpen] = useState(false)
    const [clonedPagesHTML, _setClonedPagesHTML] = useState('')
    const setClonedPagesHTML = _setClonedPagesHTML
    const [quickPrintTriggerCount, setQuickPrintTriggerCount] = useState(0)
    const quickPrintContainerRef = useRef(null)
    const [pdfUrl, setPdfUrl] = useState(null)
    const [pdfBlob, setPdfBlob] = useState(null) // Store PDF blob for downloading
    const [isDownloadMode, setIsDownloadMode] = useState(false) // Track if drawer is in download mode
    const [shouldAutoPrint, setShouldAutoPrint] = useState(false)
    const [pdfGenerating, setPdfGenerating] = useState(false)
    const [pdfProgressMessage, setPdfProgressMessage] = useState('')
    
    // Mobile drawer states
    const [mobileHistoryDrawerOpen, setMobileHistoryDrawerOpen] = useState(false)
    const [mobileRxDrawerOpen, setMobileRxDrawerOpen] = useState(false)
    const [mobileVitalsDrawerOpen, setMobileVitalsDrawerOpen] = useState(false)
    
    // Paged.js print hook for history drawer
    const { printWithPaged, isPrinting: isPagedPrinting, error: _pagedPrintError } = usePagedPrintHistory()
    
    // Paper Rx Template drawer state
    const [templateDrawerOpen, setTemplateDrawerOpen] = useState(false)
    const [paperPrescriptionTemplate, setPaperPrescriptionTemplate] = useState(null)
    const [templateLoading, setTemplateLoading] = useState(false)
    const currentEmrSectionsData = useSelector(selectEmrSectionsData)
    const currentEmrSections = (currentEmrSectionsData?.data || {})?.prescription?.emrSections || []
    
    // Get prescription data for template (only when template is loaded)
    const { currentTemplateWithDummyData, loadingPrescriptionData: loadingTemplatePrescriptionData } = usePrescriptionDataForTemplate({
      templateData: paperPrescriptionTemplate || null,
      useEmptyBox: false,
      eventId: eventId || null,
    })
    // Load colorMode from localStorage, default to 'colored'
    const [colorMode, setColorMode] = useState(() => {
      const savedColorMode = localStorage.getItem('prescriptionColorMode')
      return savedColorMode === 'bw' ? 'bw' : 'colored'
    })
    
    // Save colorMode to localStorage when it changes
    const _handleColorModeChange = (newMode) => {
      setColorMode(newMode)
      localStorage.setItem('prescriptionColorMode', newMode)
    }

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    // Guard dialog state for pre-save validation
    const [guardDialog, setGuardDialog] = useState({ open: false, guardDef: null })

    const dispatch = useDispatch()

    const { printSettings, setPrintSettings } = usePrescriptionViewSettingsForRx({
      metaPrescription: auxiliaryDataFromProps?.metaPrescription,
      prescriptionViewSettings: prescrpitionViewSettingsStoreData?.data,
    })
    
    // Fetch prescription template when drawer opens (moved after printSettings is defined)
    useEffect(() => {
      if (templateDrawerOpen) {
        const fetchTemplate = async () => {
          setTemplateLoading(true)
          setPaperPrescriptionTemplate(null) // Reset template
          try {
            // First, try to use the template from printSettings if available
            if (printSettings?.selectedPrescriptionTemplate?.id) {
              console.log('[Template Drawer] Using template from printSettings:', printSettings.selectedPrescriptionTemplate.id)
              setPaperPrescriptionTemplate({
                ...printSettings.selectedPrescriptionTemplate,
                clinicId: printSettings.selectedPrescriptionTemplate.clinicId || clinicId,
              })
              setTemplateLoading(false)
              return
            }
            
            // Check both clinicLocationId and clinicId from BookedEventInfo (both represent clinicLocationId)
            const clinicLocationId = propBookedEventInfo?.clinicLocationId || 
                                    propBookedEventInfo?.clinicId || 
                                    bookedEventInfo?.clinicLocationId || 
                                    bookedEventInfo?.clinicId || 
                                    clinicId
            console.log('[Template Drawer] Fetching template for clinicLocationId:', clinicLocationId, {
              propBookedEventInfo_clinicLocationId: propBookedEventInfo?.clinicLocationId,
              propBookedEventInfo_clinicId: propBookedEventInfo?.clinicId,
              bookedEventInfo_clinicLocationId: bookedEventInfo?.clinicLocationId,
              bookedEventInfo_clinicId: bookedEventInfo?.clinicId,
              clinicId,
            })
            
            if (clinicLocationId) {
              const response = await getMPDataWithParams('/api/secure/doctor/prescription-template', {
                clinicId: clinicLocationId === 'private' ? null : clinicLocationId,
              })
              
              console.log('[Template Drawer] API Response:', {
                status: response?.status,
                hasData: !!response?.data,
                dataType: Array.isArray(response?.data) ? 'array' : typeof response?.data,
                dataLength: Array.isArray(response?.data) ? response?.data.length : 'N/A',
                fullResponse: response?.data,
              })
              
              if (response?.status === 200) {
                // Response data might be an array directly or wrapped
                let templates = []
                if (Array.isArray(response?.data)) {
                  templates = response.data
                } else if (response?.data?.data && Array.isArray(response.data.data)) {
                  templates = response.data.data
                } else if (response?.data && typeof response.data === 'object') {
                  // Try to find templates in the response object
                  templates = response.data.templates || response.data.prescriptionTemplates || []
                }
                
                console.log('[Template Drawer] Templates found:', templates.length, templates)
                
                const paperTemplates = templates?.filter(
                  (template) =>
                    template?.prescriptionTemplateType === 'print' || !template?.prescriptionTemplateType,
                ) || []
                
                console.log('[Template Drawer] Paper templates found:', paperTemplates.length, paperTemplates)
                
                const activeTemplate = paperTemplates?.find((template) => template?.active)
                const selectedTemplate = activeTemplate || paperTemplates?.[0]
                
                if (selectedTemplate) {
                  console.log('[Template Drawer] Selected template:', selectedTemplate.id || selectedTemplate.title)
                  // Ensure template has clinicId for the hook to work
                  setPaperPrescriptionTemplate({
                    ...selectedTemplate,
                    clinicId: selectedTemplate.clinicId || clinicLocationId,
                  })
                } else {
                  console.warn('[Template Drawer] No template found. Available templates:', templates.length)
                  // If no template found, try to create a minimal template structure
                  setPaperPrescriptionTemplate({
                    id: 'default',
                    clinicId: clinicLocationId,
                    prescriptionTemplateType: 'print',
                  })
                }
              } else {
                console.error('[Template Drawer] API call failed:', response?.status, response?.data)
                // Fallback: create minimal template
                setPaperPrescriptionTemplate({
                  id: 'default',
                  clinicId: clinicLocationId,
                  prescriptionTemplateType: 'print',
                })
              }
            } else {
              console.warn('[Template Drawer] No clinicLocationId available')
              setPaperPrescriptionTemplate(null)
            }
          } catch (error) {
            console.error('[Template Drawer] Error fetching prescription template:', error)
            setPaperPrescriptionTemplate(null)
          } finally {
            setTemplateLoading(false)
          }
        }
        fetchTemplate()
      } else {
        // Reset template when drawer closes
        setPaperPrescriptionTemplate(null)
      }
    }, [templateDrawerOpen, propBookedEventInfo?.clinicLocationId, propBookedEventInfo?.clinicId, bookedEventInfo?.clinicLocationId, bookedEventInfo?.clinicId, clinicId, printSettings?.selectedPrescriptionTemplate])

    const notesRef = useRef(null)
    const vitalsRef = useRef(null)
    const fetchedBookedEventVitalsRef = useRef(new Set())

    const patientHistoryNotesRef = useRef(null)
    const pdfIframeRef = useRef(null)

    async function getAndSetAllPatientVital() {
      const patientVitals = await getPatientVitalForBookedEvent(
        patientId,
        clinicId,
        undefined,
        false,
      )
      setAllVitalsOfThisPatient(patientVitals)
    }

    useEffect(() => {
      const bookedEventId = bookedEventInfo?.id || eventId
      if (
        !hasEnabledPatientVitalsSection ||
        !patientId ||
        !clinicId ||
        !bookedEventId ||
        currentBookedEventVital
      ) {
        return
      }

      if (fetchedBookedEventVitalsRef.current.has(bookedEventId)) {
        return
      }

      let cancelled = false
      fetchedBookedEventVitalsRef.current.add(bookedEventId)

      getPatientVitalForBookedEvent(patientId, clinicId, bookedEventId, true)
        .then((vital) => {
          if (cancelled || !vital) return

          setAllVitalsOfThisPatient((prev) => {
            const existingVitals = Array.isArray(prev) ? prev : []
            const nextVital = {
              ...vital,
              bookedEventId: vital.bookedEventId || bookedEventId,
            }
            return [
              ...existingVitals.filter((item) => item?.bookedEventId !== bookedEventId),
              nextVital,
            ]
          })
        })
        .catch((error) => {
          fetchedBookedEventVitalsRef.current.delete(bookedEventId)
          console.error('Failed to fetch booked event vitals:', error)
        })

      return () => {
        cancelled = true
      }
    }, [
      bookedEventInfo?.id,
      clinicId,
      currentBookedEventVital,
      eventId,
      hasEnabledPatientVitalsSection,
      patientId,
      setAllVitalsOfThisPatient,
    ])

    const ensureEmptyRowsForTables = useCallback(() => {
      // Wait for emrSections to load before adding empty rows. Without this guard the
      // function runs twice – once (before emrSections arrives) for drugsAdvice, and
      // once (after emrSections arrives) for selectedDiagnosis – causing two separate
      // context changes and two full PMP re-renders. Waiting for emrSections means both
      // setDrugsAdvice and setSelectedDiagnosis are called in the same synchronous
      // callback, React batches them into ONE render.
      if (!emrSections) return

      const createEmptyDrugRow = () => ({
        drug: null,
        dosage: null,
        whatTime: null,
        frequency: null,
        duration: null,
        notes: null,
      })

      const createEmptyDiagnosisRow = () => ({
        title: null,
        value: null,
        duration: null,
        date: null,
      })

      setDrugsAdvice((currentDrugs) => {
        const drugs = currentDrugs || []
        const lastDrug = drugs[drugs.length - 1]
        const hasFilledLastRow = lastDrug?.drug

        if (drugs.length === 0 || hasFilledLastRow) {
          return [...drugs, createEmptyDrugRow(), createEmptyDrugRow()]
        }
        return drugs
      })

      setSelectedDiagnosis((currentDiagnosis) => {
        const diagnosis = currentDiagnosis || []
        const diagnosisSection = emrSections?.find((s) => s.id === 'diagnosis')

        if (!isDiagnosisSectionIsATable(diagnosisSection)) {
          return diagnosis
        }

        const lastDiagnosis = diagnosis[diagnosis.length - 1]
        const hasFilledLastRow = lastDiagnosis?.label || lastDiagnosis?.value

        if (diagnosis.length === 0 || hasFilledLastRow) {
          return [...diagnosis, createEmptyDiagnosisRow(), createEmptyDiagnosisRow()]
        }
        return diagnosis
      })
    }, [emrSections, setDrugsAdvice, setSelectedDiagnosis])

    function processAndSetPageData(
      metaPrescriptionData,
      screeningReportData,
      drugTypes,
      screeningReportTemplateData,
      emrSectnDataList,
      screeningEmrSectionDataList,
      precomputedTherapist = null,
    ) {
      let _patientPrefill = { ...(metaPrescriptionData?.patientPrefill || {}) }
      let prescData = { ...(metaPrescriptionData?.prescriptionData || {}) }
      let prescriptionTemplateData = {
        ...(metaPrescriptionData || {}),
        patientPrefill: null,
        prescData: null,
      }

      // const {
      //   patientPrefill,
      //   prescriptionData: prescData,
      //   ...prescriptionTemplateData
      // } = metaPrescriptionData

      setNotesToTherapist(prescData?.notesToTherapist)
      setNotesForAssessments(prescData?.notesForAssessment)

      getAndSetScreeningData(screeningReportData)
      setPrintSettings((prev) => ({
        ...prev,
        selectedPrescriptionTemplate: prescriptionTemplateData,
      }))

      if (
        !!prescriptionData &&
        prescriptionData?.id === metaPrescriptionData?.id &&
        dayjs(prescriptionData?.modifiedTime).isSame(dayjs(prescData?.modifiedTime))
      ) {
        return
      }

      // Preserve uploadedImages and uploadedSignedImages if they exist in current state
      // but are missing from the new data (to prevent losing images when data is refreshed)
      // Use functional update to always read the latest state
      setPrescriptionData((prevPrescriptionData) => {
        const existingUploadedImages = prevPrescriptionData?.prescriptionData?.uploadedImages
        const existingUploadedSignedImages = prevPrescriptionData?.prescriptionData?.uploadedSignedImages
        
        // Check if the new data explicitly includes uploadedImages/uploadedSignedImages
        // If the field exists in the response (even if undefined/empty), use it
        // If the field doesn't exist in the response, preserve existing
        const hasUploadedImagesInResponse = 'uploadedImages' in (metaPrescriptionData?.prescriptionData || {})
        const hasUploadedSignedImagesInResponse = 'uploadedSignedImages' in (metaPrescriptionData?.prescriptionData || {})
        
        const newUploadedImages = metaPrescriptionData?.prescriptionData?.uploadedImages
        const newUploadedSignedImages = metaPrescriptionData?.prescriptionData?.uploadedSignedImages
        
        // Preserve existing images if:
        // 1. The field doesn't exist in the new response, OR
        // 2. The field is explicitly undefined/null in the new response AND we have existing images
        const shouldPreserveImages = 
          (!hasUploadedImagesInResponse || (newUploadedImages === undefined || newUploadedImages === null)) && 
          existingUploadedImages && 
          existingUploadedImages.length > 0
        
        const shouldPreserveSignedImages = 
          (!hasUploadedSignedImagesInResponse || (newUploadedSignedImages === undefined || newUploadedSignedImages === null)) && 
          existingUploadedSignedImages && 
          existingUploadedSignedImages.length > 0
        
        const finalPrescriptionData = {
          ...metaPrescriptionData,
          prescriptionData: {
            ...metaPrescriptionData?.prescriptionData,
            // Preserve existing images if new data doesn't explicitly provide them
            uploadedImages: shouldPreserveImages ? existingUploadedImages : (newUploadedImages || existingUploadedImages),
            uploadedSignedImages: shouldPreserveSignedImages ? existingUploadedSignedImages : (newUploadedSignedImages || existingUploadedSignedImages),
          },
        }

        return finalPrescriptionData
      })
      if (metaPrescriptionData?.prescriptionData?.jointHomunculusData) {
        setJointHomunculusData(metaPrescriptionData?.prescriptionData?.jointHomunculusData)
      }
      // setScreeningReportData(response?.data?.data?.screeningReport)
      if (metaPrescriptionData?.prescriptionData?.drugInfoList) {
        setDrugsAdvice(
          getInitialDataForSettingExistingDrugAdvice(
            metaPrescriptionData?.prescriptionData?.drugInfoList,
            drugTypes || drugAdviceTypes,
          ),
        )
      }
      if (metaPrescriptionData?.doctorPrintType) {
        setPrintType((prev) => (prev ? prev : metaPrescriptionData?.doctorPrintType))
      } else {
        setPrintType((prev) => (prev ? prev : metaPrescriptionData?.doctorPrintType))
      }

      setSelectedComplaints(
        getInitialDataForSettingExistingHealthEntity(
          metaPrescriptionData?.prescriptionData?.complaints,
        ),
      )
      setSelectedDiagnosis(
        getInitialDataForSettingExistingHealthEntity(
          metaPrescriptionData?.prescriptionData?.diagnosis,
        ),
      )

      setFinalRequestedTestsBy(metaPrescriptionData?.prescriptionData?.finishRequestedTestsBy)

      setSelectedAssessments(
        getInitialDataForSettingExistingHealthEntity(
          metaPrescriptionData?.prescriptionData?.psychAssessments,
        ),
      )

      setAttachPrescriptionForTherapy(
        metaPrescriptionData?.prescriptionData?.attachPrescriptionForTherapy || true,
      )

      setAttachPrescriptionForAssessments(
        metaPrescriptionData?.prescriptionData?.attachPrescriptionForAssessments || true,
      )

      setSelectedInvestigations(
        getInitialDataForSettingExistingHealthEntity(
          metaPrescriptionData?.prescriptionData?.investigations,
        ),
      )
      setSelectedObservations(
        getInitialDataForSettingExistingHealthEntity(
          metaPrescriptionData?.prescriptionData?.healthObservations,
          metaPrescriptionData?.prescriptionData?.symptomsAndObservations,
        ),
      )
      setSelectedAdvice(
        getInitialDataForSettingExistingHealthEntity(
          metaPrescriptionData?.prescriptionData?.prescriptionAdvices,
          metaPrescriptionData?.prescriptionData?.guidanceAndAdvices,
        ),
      )
      setSelectedInstructions(
        getInitialDataForSettingExistingHealthEntity(
          metaPrescriptionData?.prescriptionData?.healthInstructions,
          metaPrescriptionData?.prescriptionData?.instructions,
        ),
      )
      if (metaPrescriptionData?.prescriptionData?.nextVisitDate) {
        setNextVisitInputValue(
          getInitialDataForSettingDaysOfNextVisit(
            metaPrescriptionData?.prescriptionData?.nextVisitDate,
            metaPrescriptionData?.prescriptionData?.createdTime,
            prescData?.nextVisitTypeToShow,
          ),
        )
      }
      if (metaPrescriptionData?.prescriptionData?.referredToDoctorName) {
        setReferredToDoctorName(metaPrescriptionData?.prescriptionData?.referredToDoctorName)
      }
      if (metaPrescriptionData?.prescriptionData?.therapiesNeeded) {
        setSelectedTherapies(
          getInitialDataForSettingExistingSelectedTherapies(
            metaPrescriptionData?.prescriptionData?.therapiesNeeded,
          ),
        )
      }
      if (precomputedTherapist) {
        setSelectedTherapist(precomputedTherapist)
      }

      if (prescData?.nextVisitTypeToShow) {
        setNextVisitInputType(prescData?.nextVisitTypeToShow)
      }
      let emrSectionDataListToSet
      if (emrSectnDataList) {
        emrSectionDataListToSet = emrSectnDataList
      }
      //else {
      //   let screeningRecommendationData = screeningEmrSectionDataList?.find(
      //     (s) => s.sectionCode === 'SCREENING_RECOMMENDATION',
      //   )
      //   if (screeningRecommendationData) {
      //     screeningRecommendationData = setEmrSectionDataList([screeningRecommendationData])
      //   }
      // }
      if (
        !emrSectionDataListToSet?.some(
          (emrData) => emrData.sectionCode === 'SCREENING_RECOMMENDATION',
        )
      ) {
        let screeningRecommendationData = screeningEmrSectionDataList?.find(
          (s) => s.sectionCode === 'SCREENING_RECOMMENDATION',
        )
        if (screeningRecommendationData) {
          screeningRecommendationData = {
            ...screeningRecommendationData,
            id: undefined,
            reportType: null,
          }
          emrSectionDataListToSet = [
            ...(emrSectionDataListToSet || []),
            screeningRecommendationData,
          ]
        }
      }

      setEmrSectionDataList(emrSectionDataListToSet || [])
      setFreeFormRichText(
        metaPrescriptionData?.prescriptionData?.freeFormRichText ||
          getFreeFormRichTextFromEmrSectionDataList(emrSectionDataListToSet) ||
          '',
      )
      setPrescriptionId(metaPrescriptionData?.prescriptionData?.prescriptionId || null)

      if (honorPropValue) {
        if (propValue) {
          setValue(propValue)
        } else {
          if (metaPrescriptionData?.prescriptionData?.content) {
            setValue(metaPrescriptionData?.prescriptionData?.content)
            setPropValue(metaPrescriptionData?.prescriptionData?.content)
          } else {
            setValue('')
            setPropValue('')
          }
        }
      } else {
        if (metaPrescriptionData?.prescriptionData?.content) {
          setValue(metaPrescriptionData?.prescriptionData?.content)
        } else {
          setValue('')
        }
      }

      // NOTE: ensureEmptyRowsForTables() is called via its useEffect (deps: drugsAdvice,
      // selectedDiagnosis, emrSections). It fires after this batch commits and adds sentinel
      // empty rows to drugsAdvice and selectedDiagnosis. The !emrSections guard ensures both
      // setters run in the same synchronous callback so React batches them into one render.
    }

    async function getAndSetPrescriptionData(mentorResponseData, drugTypes) {
      let metaPrescription
      let screeningReportData
      let screeningReportTemplateData
      let emrSectnDataList
      let screeningEmrSectionDataList = auxiliaryDataFromProps?.['screening__EmrSectionData']
      if (auxiliaryDataFromProps?.metaPrescription || auxiliaryDataFromProps?.screeningReport) {
        metaPrescription = auxiliaryDataFromProps.metaPrescription
        screeningReportData = auxiliaryDataFromProps.screeningReport
        screeningReportTemplateData = auxiliaryDataFromProps.screeningReportTemplate
      }
      // else {
      //   const response = await getMPDataWithoutParams(
      //     `/api/secure/doctor/prescription/get-by-eventId?eventId=${eventId}`,
      //   )
      //   if (response.status === 200) {
      //     metaPrescription = response?.data?.data?.metaPrescription
      //     screeningReportData = response?.data?.data?.screeningReport
      //   } else {
      //     toast.error('Error getting prescription data')
      //   }
      // }

      if (!!screeningReportData && !!mentorResponseData) {
        getScreeningSections(mentorResponseData)
      }
      emrSectnDataList = auxiliaryDataFromProps?.emrSectionData

      // Pre-compute therapist data (requires async API lookup) before batching state updates.
      // This avoids an await in the middle of processAndSetPageData which would split
      // React 18's automatic batching, causing multiple expensive re-renders.
      let precomputedTherapist = null
      const _prescData = metaPrescription?.prescriptionData
      if (_prescData?.requestedTherapist) {
        precomputedTherapist = await getInitialDataForSettingSelectedTherapist(
          _prescData.requestedTherapist,
        )
      } else if (screeningReportData?.suggestedBookingTherapy && screeningReportData?.mentorId) {
        precomputedTherapist = await getInitialDataForSettingSelectedTherapist({
          id: screeningReportData.mentorId,
        })
      }

      processAndSetPageData(
        metaPrescription,
        screeningReportData,
        drugTypes,
        screeningReportTemplateData,
        emrSectnDataList,
        screeningEmrSectionDataList,
        precomputedTherapist,
      )
    }

    async function autofillPrescriptionUsingData(lastData) {
      if (!lastData?.prescriptionData) {
        toast.error('No prescription data available to autofill', { autoClose: 3000 })
        return
      }

      const prescData = lastData.prescriptionData

      // Set notes
      if (prescData?.notesToTherapist !== undefined) {
        setNotesToTherapist(prescData.notesToTherapist)
      }
      if (prescData?.notesForAssessment !== undefined) {
        setNotesForAssessments(prescData.notesForAssessment)
      }

      // Set joint homunculus data
      if (prescData?.jointHomunculusData) {
        setJointHomunculusData(prescData.jointHomunculusData)
      }

      // Set drug advice
      if (prescData?.drugInfoList) {
        setDrugsAdvice(
          getInitialDataForSettingExistingDrugAdvice(
            prescData.drugInfoList,
            drugAdviceTypes,
          ),
        )
      }

      // Set health entities
      setSelectedComplaints(
        getInitialDataForSettingExistingHealthEntity(prescData?.complaints),
      )
      setSelectedDiagnosis(
        getInitialDataForSettingExistingHealthEntity(prescData?.diagnosis),
      )
      setSelectedAssessments(
        getInitialDataForSettingExistingHealthEntity(prescData?.psychAssessments),
      )
      setSelectedInvestigations(
        getInitialDataForSettingExistingHealthEntity(prescData?.investigations),
      )
      setSelectedObservations(
        getInitialDataForSettingExistingHealthEntity(
          prescData?.healthObservations,
          prescData?.symptomsAndObservations,
        ),
      )
      setSelectedAdvice(
        getInitialDataForSettingExistingHealthEntity(
          prescData?.prescriptionAdvices,
          prescData?.guidanceAndAdvices,
        ),
      )
      setSelectedInstructions(
        getInitialDataForSettingExistingHealthEntity(
          prescData?.healthInstructions,
          prescData?.instructions,
        ),
      )

      // Set final requested tests by
      if (prescData?.finishRequestedTestsBy !== undefined) {
        setFinalRequestedTestsBy(prescData.finishRequestedTestsBy)
      }

      // Set attachment flags
      setAttachPrescriptionForTherapy(
        prescData?.attachPrescriptionForTherapy ?? false,
      )
      setAttachPrescriptionForAssessments(
        prescData?.attachPrescriptionForAssessments ?? false,
      )

      // Set next visit data
      if (prescData?.nextVisitDate) {
        setNextVisitInputValue(
          getInitialDataForSettingDaysOfNextVisit(
            prescData.nextVisitDate,
            prescData.createdTime,
            prescData.nextVisitTypeToShow,
          ),
        )
      }
      if (prescData?.nextVisitTypeToShow) {
        setNextVisitInputType(prescData.nextVisitTypeToShow)
      }

      // Set referred doctor
      if (prescData?.referredToDoctorName) {
        setReferredToDoctorName(prescData.referredToDoctorName)
      }

      // Set therapies
      if (prescData?.therapiesNeeded) {
        setSelectedTherapies(
          getInitialDataForSettingExistingSelectedTherapies(prescData.therapiesNeeded),
        )
      }

      // Set therapist (async)
      if (prescData?.requestedTherapist) {
        try {
          const therapistData = await getInitialDataForSettingSelectedTherapist(
            prescData.requestedTherapist,
          )
          setSelectedTherapist(therapistData)
        } catch (error) {
          console.error('Error setting therapist:', error)
        }
      }

      // Set prescription content/notes (value)
      if (prescData?.content) {
        if (honorPropValue) {
          setValue(prescData.content)
          if (setPropValue) {
            setPropValue(prescData.content)
          }
        } else {
          setValue(prescData.content)
        }
      }

      // Set print type if available (can be at top level from prescriptionTemplateToConsider)
      if (lastData?.doctorPrintType) {
        setPrintType((prev) => (prev ? prev : lastData.doctorPrintType))
      }

      // Set print settings/template if available
      if (lastData && Object.keys(lastData).length > 0) {
        const prescriptionTemplateData = {
          ...lastData,
          patientPrefill: null,
          prescriptionData: null,
        }
        setPrintSettings((prev) => ({
          ...prev,
          selectedPrescriptionTemplate: prescriptionTemplateData,
        }))
      }

      // Set EMR section data list if available
      if (prescData?.emrSectionDataList && Array.isArray(prescData.emrSectionDataList)) {
        setEmrSectionDataList(prescData.emrSectionDataList)
      }

      // Set screening data if available (from lastData, not prescData)
      // Note: Screening data might be in a separate field or might need to be fetched
      // For now, we'll skip it as it's typically event-specific, not prescription-specific

      // Ensure empty rows for tables after a short delay to allow state updates to complete
      setTimeout(() => {
        ensureEmptyRowsForTables()
      }, 100)

      toast.success('Previous prescription data applied successfully', { autoClose: 2000 })
    }

    useEffect(() => {
      if (!mobileVitalsDrawerOpen) return
      if (!patientId || !clinicId) return
      if (Array.isArray(allVitalsOfThisPatient) && allVitalsOfThisPatient.length > 0) return
      getAndSetAllPatientVital()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mobileVitalsDrawerOpen, patientId, clinicId, allVitalsOfThisPatient?.length])

    async function getDrugAdviceNotes() {
      dispatch(fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_NOTE }))
    }
    async function getDrugAdviceDuration() {
      dispatch(fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_DURATION }))
    }
    async function getDrugAdviceDosage() {
      dispatch(fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_DOSAGE }))
    }
    async function getDrugAdviceFreq() {
      dispatch(fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_FREQUENCY }))
    }
    async function getDrugAdviceWhen() {
      dispatch(fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_TIMING }))
    }
    async function getDrugInfoTypes() {
      dispatch(fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_TYPE }))
    }

    async function getEMRMeta() {
      const response = await getMPDataWithParams(`/api/secure/teacher/next-visit-widget/get`, {
        'event-id': eventId,
      })
      if (response.status === 200) {
        if (isCommonResponseSuccessfulV2(response)) {
          const respData = getDataMapFromCommonResponse(response)?.['emrMeta']
          const _isProduction = isAppRunningInProduction()
          // const shouldShowNextVisitSlotSelector = !_isProduction
          //   ? response.data?.nextVisitHoldSlot?.doctors
          //   : true
          const shouldShowNextVisitSlotSelector = respData?.nextVisitHoldSlot?.doctors
          setShowNextVisitSlotSelector(shouldShowNextVisitSlotSelector)
        }
      }
    }

    async function setup() {
      getEMRMeta()
      const mentorResponseData = await refreshMentorProfile()
      const isDoctorRole = getAllRolesInBoolean().isDoctor
      const canProceed =
        eventId &&
        patientId &&
        isDoctorRole &&
        mentorResponseData?.allowedToPrescribe
      if (
        canProceed
      ) {
        const drugTypes = await getDrugInfoTypes()
        getDrugAdviceNotes()
        getDrugAdviceDuration()
        getDrugAdviceFreq()
        getDrugAdviceWhen()
        getAndSetPrescriptionData(mentorResponseData, drugTypes)
        getDrugAdviceDosage()
      } else {
        toast('could not get prescription data')
      }
      if (bookedEventInfo?.discountAction?.discountedPrice) {
        setDiscountedPriceOfSession(bookedEventInfo?.discountAction?.discountedPrice)
        setChoseToGiveDiscount(true)
      }
    }

    // SIMPLIFIED DESIGN: Child component does NOT manage header state
    // Parent component (MentorClinicSomeChamberAutoJoiningPage) is the single source of truth
    // This component just renders its content - header is managed by parent based on selectedOptionPatientMenu
    // Removed all header-setting logic to prevent race conditions

    useEffect(() => {
      if (screenHeight < 500) {
        setButtonTopOffset(400)
      } else if (screenHeight < 600) {
        setButtonTopOffset(300)
      } else if (screenHeight < 900) {
        setButtonTopOffset(237)
      } else {
        setButtonTopOffset(100)
      }
      return () => {
        setButtonTopOffset(0)
      }
    }, [screenHeight, setButtonTopOffset])

    // Hide DocSide on this page to prevent overlap with important sections
    useEffect(() => {
      setShowDocSide(false)
      return () => {
        setShowDocSide(true) // Re-enable when leaving this page
      }
    }, [setShowDocSide])

    useEffect(() => {
      // Only run setup when something MEANINGFUL changed:
      //   • eventId or patientId changed (different prescription)
      //   • auxiliaryDataFromProps just arrived for the first time (null/undefined → non-null)
      // We intentionally skip re-runs when only the aux-data *reference* changes while the
      // content is the same (the parent calls setAuxiliaryData multiple times on re-fetch).
      const hasAux = auxiliaryDataFromProps != null
      const setupKey = `${eventId}_${patientId}_${hasAux}`
      if (setupKey === _setupKeyRef.current) {
        return
      }
      _setupKeyRef.current = setupKey
      setup()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventId, patientId, auxiliaryDataFromProps])

    // Listen for guard dialog events
    useEffect(() => {
      const handleGuardDialog = (event) => {
        setGuardDialog({ open: true, guardDef: event.detail.guardDef })
      }

      window.addEventListener('emr:show-guard-dialog', handleGuardDialog)

      return () => {
        window.removeEventListener('emr:show-guard-dialog', handleGuardDialog)
      }
    }, [])

    useEffect(() => {
      
      // Safety: If PDF URL exists and generation is complete, ensure drawer is open
      if (pdfUrl && !pdfGenerating && !pdfDrawerOpen) {
        console.warn('[PDF Drawer] PDF ready but drawer closed, forcing open')
        setPdfDrawerOpen(true)
      }
    }, [pdfDrawerOpen, pdfUrl, pdfGenerating, shouldAutoPrint, isDownloadMode])

    // Store loadingToastId in a ref so it's accessible in useEffect
    const loadingToastIdRef = useRef(null)
    
    // Helper function to dismiss loading toast reliably
    const _dismissLoadingToast = useCallback(() => {
      const toastId = loadingToastIdRef.current
      if (toastId) {
        console.log('[Dismiss Toast] Dismissing loading toast, ID:', toastId)
        toast.dismiss(toastId)
        loadingToastIdRef.current = null
        // Double-check dismissal after a short delay
        setTimeout(() => {
          if (loadingToastIdRef.current === toastId) {
            console.log('[Dismiss Toast] Toast still exists, dismissing again')
            toast.dismiss(toastId)
            loadingToastIdRef.current = null
          }
        }, 200)
      } else {
        console.warn('[Dismiss Toast] No toast ID in ref')
      }
    }, [])
    
    // Helper function to inject color mode CSS into iframe or print window
    const injectColorModeCSS = useCallback((targetWindow, isBwMode) => {
      if (!targetWindow || !targetWindow.document) {
        console.warn('[Color Mode] Cannot access target window document')
        return
      }
      
      try {
        const doc = targetWindow.document
        const head = doc.head || doc.getElementsByTagName('head')[0]
        
        // Remove existing color mode style if any
        const existingStyle = doc.getElementById('prescription-color-mode-style')
        if (existingStyle) {
          existingStyle.remove()
        }
        
        // Create new style element
        const style = doc.createElement('style')
        style.id = 'prescription-color-mode-style'
        style.type = 'text/css'
        
        if (isBwMode) {
          // B&W mode: use economy color adjustment and grayscale filter
          style.textContent = `
            @media print {
              * {
                -webkit-print-color-adjust: economy !important;
                print-color-adjust: economy !important;
                color-adjust: economy !important;
              }
              body {
                filter: grayscale(100%) !important;
                -webkit-filter: grayscale(100%) !important;
              }
            }
            @page {
              -webkit-print-color-adjust: economy !important;
              print-color-adjust: economy !important;
              color-adjust: economy !important;
            }
          `
        } else {
          // Colored mode: use exact color adjustment
          style.textContent = `
            @media print {
              * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
            }
            @page {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
          `
        }
        
        head.appendChild(style)
        console.log(`[Color Mode] Injected ${isBwMode ? 'B&W' : 'colored'} mode CSS into print window`)
      } catch (error) {
        console.warn('[Color Mode] Error injecting CSS:', error)
      }
    }, [])

    // Auto-trigger print when drawer opens with shouldAutoPrint flag
    useEffect(() => {
      if (pdfDrawerOpen && shouldAutoPrint && pdfUrl && !pdfGenerating) {
        console.log('[Auto-Print] Conditions met, waiting for PDF to load...', {
          pdfDrawerOpen,
          shouldAutoPrint,
          hasPdfUrl: !!pdfUrl,
          pdfGenerating
        })
        
        // Track all timers and intervals for cleanup
        const timers = []
        const intervals = []
        const eventListeners = []
        
        // Helper to add timer for cleanup
        const addTimer = (timer) => {
          timers.push(timer)
          return timer
        }
        
        // Helper to add interval for cleanup
        const addInterval = (interval) => {
          intervals.push(interval)
          return interval
        }
        
        // Wait for the PDF to fully load in the iframe before triggering print
        // Reduced delay for faster print triggering
        const timer = addTimer(setTimeout(() => {
          console.log('[Auto-Print] Attempting to trigger print dialog from drawer')
          // Ensure drawer stays open before printing
          setPdfDrawerOpen(true)
          
          // Try to print from the iframe in the drawer first (user's preference)
          // If that fails, fall back to opening in new window
          if (pdfIframeRef.current && pdfIframeRef.current.contentWindow) {
            try {
              console.log('[Auto-Print] Trying iframe print method from drawer')
              
              // Reduced delay for faster print
              const _innerTimer1 = addTimer(setTimeout(() => {
                try {
                  // Check if iframe is loaded
                  if (!pdfIframeRef.current || !pdfIframeRef.current.contentWindow) {
                    console.warn('[Auto-Print] Iframe not ready, using window.open fallback')
                    openPrintWindowFallback()
                    return
                  }
                  
                  // Check if PDF is loaded in iframe
                  try {
                    const iframeDoc = pdfIframeRef.current.contentDocument || pdfIframeRef.current.contentWindow.document
                    if (!iframeDoc || iframeDoc.readyState !== 'complete') {
                      console.warn('[Auto-Print] Iframe document not ready, waiting...')
                      // Wait a bit more
                      addTimer(setTimeout(() => {
                        try {
                          // Inject color mode CSS before delayed print
                          try {
                            const iframeWindow = pdfIframeRef.current.contentWindow
                            if (iframeWindow && iframeWindow.document) {
                              injectColorModeCSS(iframeWindow, colorMode === 'bw')
                            }
                          } catch (cssError) {
                            console.warn('[Auto-Print Delayed] Could not inject color mode CSS:', cssError)
                          }
                          
                          pdfIframeRef.current.contentWindow.focus()
                          pdfIframeRef.current.contentWindow.print()
                          console.log('[Auto-Print] Print dialog triggered via iframe (delayed)', { colorMode })
                          // Update loading toast to success when print dialog opens
                          const toastId = loadingToastIdRef.current
                          if (toastId) {
                            toast.update(toastId, {
                              render: 'Opening print dialog...',
                              type: 'success',
                              isLoading: false,
                              autoClose: 2000,
                            })
                            loadingToastIdRef.current = null
                          }
                        } catch (e) {
                          console.warn('[Auto-Print] Delayed iframe print failed:', e)
                          openPrintWindowFallback()
                        }
                      }, 300))
                      return
                    }
                  } catch (docError) {
                    // Cross-origin or other error accessing iframe document
                    console.warn('[Auto-Print] Cannot access iframe document, trying print anyway:', docError)
                  }
                  
                  // Inject color mode CSS into iframe before printing
                  try {
                    const iframeWindow = pdfIframeRef.current.contentWindow
                    if (iframeWindow && iframeWindow.document) {
                      injectColorModeCSS(iframeWindow, colorMode === 'bw')
                    }
                  } catch (cssError) {
                    console.warn('[Auto-Print] Could not inject color mode CSS:', cssError)
                  }
                  
              // Focus the iframe and trigger print
              pdfIframeRef.current.contentWindow.focus()
              pdfIframeRef.current.contentWindow.print()
                  console.log('[Auto-Print] Print dialog triggered via iframe', { colorMode })
                  
                  // Dismiss loading toast when print dialog opens - use update to change to success
                  const toastId = loadingToastIdRef.current
                  if (toastId) {
                    console.log('[Auto-Print] Updating loading toast to success, ID:', toastId)
                    try {
                      toast.update(toastId, {
                        render: 'Opening print dialog...',
                        type: 'success',
                        isLoading: false,
                        autoClose: 2000,
                      })
                    } catch (updateError) {
                      console.warn('[Auto-Print] Toast update failed, dismissing:', updateError)
                      toast.dismiss(toastId)
                    }
                    loadingToastIdRef.current = null
                  } else {
                    console.warn('[Auto-Print] No toast ID, dismissing all toasts')
                    toast.dismiss()
                  }
                  
                  // Listen for afterprint event to reset flag
              const handleAfterPrint = () => {
                    console.log('[Auto-Print] Print dialog closed')
                setShouldAutoPrint(false)
                setPdfDrawerOpen(true)
                window.removeEventListener('afterprint', handleAfterPrint)
              }
              window.addEventListener('afterprint', handleAfterPrint)
              
                  // Fallback timeout in case afterprint doesn't fire
                  const _fallbackTimer = addTimer(setTimeout(() => {
                setShouldAutoPrint(false)
                setPdfDrawerOpen(true)
                  }, 5000))
                } catch (iframeError) {
                  console.warn('[Auto-Print] Iframe print failed, using window.open fallback:', iframeError)
                  // Fallback to window.open if iframe print fails
                  openPrintWindowFallback()
                }
              }, 300)) // Wait 300ms for PDF to load in iframe - closes both setTimeout and addTimer
            } catch (e) {
              console.warn('[Auto-Print] Iframe access failed, using window.open fallback:', e)
              openPrintWindowFallback()
            }
          } else {
            console.log('[Auto-Print] Iframe not ready, using window.open fallback')
            openPrintWindowFallback()
          }
          
          // Helper function for window.open fallback
          function openPrintWindowFallback() {
            console.log('[Auto-Print] Opening PDF in new window for printing (fallback)')
              const printWindow = window.open(pdfUrl, '_blank')
            
              if (printWindow) {
              // Wait for the window to load, then trigger print
              const checkWindowLoaded = addInterval(setInterval(() => {
                try {
                  if (printWindow.document && printWindow.document.readyState === 'complete') {
                    clearInterval(checkWindowLoaded)
                    console.log('[Auto-Print] New window loaded, triggering print')
                    
                    const _printTimer = addTimer(setTimeout(() => {
                      try {
                        // Inject color mode CSS into print window before printing
                        injectColorModeCSS(printWindow, colorMode === 'bw')
                        
                    printWindow.print()
                        console.log('[Auto-Print] Print dialog triggered in new window', { colorMode })
                        
                        // Dismiss loading toast when print dialog opens
                        const toastId = loadingToastIdRef.current
                        if (toastId) {
                          toast.dismiss(toastId)
                          toast.update(toastId, {
                            render: 'Opening print dialog...',
                            type: 'success',
                            isLoading: false,
                            autoClose: 2000,
                          })
                          loadingToastIdRef.current = null
                        } else {
                          toast.dismiss()
                        }
                        
                        const handleAfterPrint = () => {
                      setShouldAutoPrint(false)
                      setPdfDrawerOpen(true)
                          window.removeEventListener('afterprint', handleAfterPrint)
                        }
                        eventListeners.push({ type: 'afterprint', handler: handleAfterPrint })
                        window.addEventListener('afterprint', handleAfterPrint)
                        
                        const _fallbackTimer2 = addTimer(setTimeout(() => {
                          setShouldAutoPrint(false)
                          setPdfDrawerOpen(true)
                        }, 5000))
                      } catch (printError) {
                        console.error('[Auto-Print] Error triggering print:', printError)
                        // Dismiss loading toast on error
                        if (loadingToastIdRef.current) {
                            const toastId = loadingToastIdRef.current
                            if (toastId) {
                              toast.update(toastId, {
                                render: 'Opening print dialog...',
                                type: 'success',
                                isLoading: false,
                                autoClose: 2000,
                              })
                              loadingToastIdRef.current = null
                            }
                        }
                        toast.error('Failed to open print dialog. Please try printing manually.', { autoClose: 5000 })
                    setShouldAutoPrint(false)
                      }
                    }, 800))
                  }
                } catch (e) {
                  try {
                    if (printWindow.closed) {
                      clearInterval(checkWindowLoaded)
                      setShouldAutoPrint(false)
                    }
                  } catch (checkError) {
                    if (checkWindowLoaded) {
                      clearInterval(checkWindowLoaded)
                    }
                    console.error('[Auto-Print] Cannot access print window:', checkError)
                    // Dismiss loading toast on error
                    // Update loading toast to error
                    const toastId = loadingToastIdRef.current
                    if (toastId) {
                      toast.update(toastId, {
                        render: 'Error opening print dialog',
                        type: 'error',
                        isLoading: false,
                        autoClose: 3000,
                      })
                      loadingToastIdRef.current = null
                    }
                    toast.error('Popup blocked. Please allow popups and try again.', { autoClose: 5000 })
                    setShouldAutoPrint(false)
                  }
                }
              }, 100))
              
              const _timeoutTimer = addTimer(setTimeout(() => {
                if (checkWindowLoaded) {
                  clearInterval(checkWindowLoaded)
                }
                try {
                  if (printWindow && !printWindow.closed && printWindow.document) {
                    printWindow.print()
                    // Dismiss loading toast when print is triggered
                    // Update loading toast to error
                    const toastId = loadingToastIdRef.current
                    if (toastId) {
                      toast.update(toastId, {
                        render: 'Error opening print dialog',
                        type: 'error',
                        isLoading: false,
                        autoClose: 3000,
                      })
                      loadingToastIdRef.current = null
                    }
                  }
                } catch (e) {
                  console.error('[Auto-Print] Timeout: Could not trigger print:', e)
                  // Dismiss toast even on timeout error
                  if (loadingToastIdRef.current) {
                            const toastId = loadingToastIdRef.current
                            if (toastId) {
                              toast.update(toastId, {
                                render: 'Opening print dialog...',
                                type: 'success',
                                isLoading: false,
                                autoClose: 2000,
                              })
                              loadingToastIdRef.current = null
                            }
                  }
                }
              }, 5000))
            } else {
              console.error('[Auto-Print] Failed to open new window (popup blocked)')
              // Dismiss loading toast on popup blocked
              // Update loading toast to error
              const toastId = loadingToastIdRef.current
              if (toastId) {
                toast.update(toastId, {
                  render: 'Error opening print dialog',
                  type: 'error',
                  isLoading: false,
                  autoClose: 3000,
                })
                loadingToastIdRef.current = null
              }
              toast.error('Popup blocked. Please allow popups and try again.', { autoClose: 5000 })
              setShouldAutoPrint(false)
            }
          }
        }, 800)) // Wait 800ms for PDF to load in drawer iframe
        
        // Cleanup function: clear all timers, intervals, and event listeners
        return () => {
          console.log('[Auto-Print] Cleaning up timers, intervals, and event listeners')
          // Clear all timers
          timers.forEach(t => {
            if (t) clearTimeout(t)
          })
          // Clear all intervals
          intervals.forEach(i => {
            if (i) clearInterval(i)
          })
          // Remove all event listeners
          eventListeners.forEach(({ type, handler }) => {
            try {
              window.removeEventListener(type, handler)
            } catch (e) {
              console.warn(`[Auto-Print] Error removing ${type} listener:`, e)
            }
          })
          // Clear the main timer
          if (timer) clearTimeout(timer)
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pdfDrawerOpen, shouldAutoPrint, pdfUrl, pdfGenerating, colorMode])
    
    // Prevent drawer from closing when auto-print is active OR during PDF generation
    // This effect only ensures drawer stays open when it should, it doesn't force opening
    useEffect(() => {
      // Only act if drawer is already open (don't force open)
      if (!pdfDrawerOpen) {
        return
      }
      
      // Keep drawer open during PDF generation
      if (pdfGenerating) {
        setPdfDrawerOpen(true)
        return
      }
      
      // Keep drawer open when auto-print is active with PDF ready
      if (shouldAutoPrint && pdfUrl) {
        setPdfDrawerOpen(true)
        return
      }
    }, [shouldAutoPrint, pdfUrl, pdfGenerating, pdfDrawerOpen])
    
    // Listen for print dialog events to keep drawer open
    useEffect(() => {
      const handleBeforePrint = () => {
        // Keep drawer open when print dialog opens
        if (shouldAutoPrint && pdfUrl) {
          setPdfDrawerOpen(true)
        }
      }
      
      const handleAfterPrint = () => {
        // Keep drawer open after print dialog closes
        if (shouldAutoPrint && pdfUrl) {
          setPdfDrawerOpen(true)
        }
      }
      
      window.addEventListener('beforeprint', handleBeforePrint)
      window.addEventListener('afterprint', handleAfterPrint)
      
      return () => {
        window.removeEventListener('beforeprint', handleBeforePrint)
        window.removeEventListener('afterprint', handleAfterPrint)
      }
    }, [shouldAutoPrint, pdfUrl])


    // Cleanup PDF URL on component unmount to prevent memory leaks
    useEffect(() => {
      return () => {
        // Cleanup function: revoke PDF URL when component unmounts
        if (pdfUrl) {
          try {
            URL.revokeObjectURL(pdfUrl)
          } catch (error) {
            console.warn('Error revoking PDF URL on unmount:', error)
          }
        }
      }
    }, [pdfUrl])

    async function refreshPrescriptionData() {
      setLoadingPrescriptionData(true)
      if (getProcessAndSetEventData) {
        // setPrescriptionData(null)
        await getProcessAndSetEventData({
          hideLoader: true,
        })
      } else {
        await getAndSetPrescriptionData(undefined, drugAdviceTypes)
      }
      setLoadingPrescriptionData(false)
    }

    async function saveNewHealthEntities(data, healthEntity, isApplyingCompleteObject = false) {
      return await saveNewHealthEntityList(
        data,
        healthEntity,
        clinicId,
        clinicBrandId,
        isApplyingCompleteObject,
      )
    }

    async function savePrescriptionData(skipRefresh = false, suppressToast = false) {
      // Save notes, vitals, and patient history notes asynchronously (non-blocking)
      // These can run in parallel and won't block the main save operation
      if (notesRef.current?.saveNote) {
        const notesPromise = notesRef.current.saveNote()
        if (notesPromise && typeof notesPromise.catch === 'function') {
          notesPromise.catch(err => {
            console.warn('Background save of notes failed:', err)
          })
        }
      }
      if (vitalsRef.current?.saveVital) {
        const vitalsPromise = vitalsRef.current.saveVital()
        if (vitalsPromise && typeof vitalsPromise.catch === 'function') {
          vitalsPromise.catch(err => {
            console.warn('Background save of vitals failed:', err)
          })
        }
      }

      if (patientHistoryNotesRef.current?.saveCurrentNotes) {
        const notesSavePromise = patientHistoryNotesRef.current.saveCurrentNotes()
        if (notesSavePromise && typeof notesSavePromise.catch === 'function') {
          notesSavePromise.catch(err => {
            console.warn('Background save of patient history notes failed:', err)
          })
        }
      }
      setPrescriptionSaveLoading(true)
      setPlaceholder('')

      // // Check all guard actions before proceeding with save
      // try {
      //   const runtime = {
      //     patientId,
      //     eventId,
      //     clinicId,
      //     clinicBrandId,
      //     recommendationId: prescriptionId,
      //   }
      //   await checkAllGuardsBeforeSave(emrSections, emrSectionDataList, runtime)
      // } catch (error) {
      //   // User cancelled a guard dialog - abort save
      //   console.log('[PrescriptionMakingPage] Guard blocked save:', error.message)
      //   setPrescriptionSaveLoading(false)
      //   return
      // }

      const newlySavedItems = {}
      let drugAdviceToSave = [...(drugsAdvice || [])]

      const saveDrugDosages = await saveNewHealthEntities(
        getDrugAdviceItems({
          drugAdviceArray: drugsAdvice,
          keyOfItem: 'dosage',
        }),
        HE_DRUG_ADVICE_DOSAGE,
      )

      const saveDrugDurations = await saveNewHealthEntities(
        getDrugAdviceItems({
          drugAdviceArray: drugsAdvice,
          keyOfItem: 'duration',
        }),
        HE_DRUG_ADVICE_DURATION,
      )
      const saveDrugNotes = await saveNewHealthEntities(
        getDrugAdviceItems({
          drugAdviceArray: drugsAdvice,
          keyOfItem: 'notes',
        }),
        HE_DRUG_ADVICE_NOTE,
      )

      const saveDrugFrequencies = await saveNewHealthEntities(
        getDrugAdviceItems({
          drugAdviceArray: drugsAdvice,
          keyOfItem: 'frequency',
        }),
        HE_DRUG_ADVICE_FREQUENCY,
      )

      const saveDrugWhatTime = await saveNewHealthEntities(
        getDrugAdviceItems({
          drugAdviceArray: drugsAdvice,
          keyOfItem: 'whatTime',
        }),
        HE_DRUG_ADVICE_TIMING,
      )
      const saveDrugType = await saveNewHealthEntities(
        getDrugAdviceItems({
          drugAdviceArray: drugsAdvice,
          keyOfItem: 'drugType',
        })?.map((type) => {
          return { ...type, shortTitle: type?.label }
        }),
        HE_DRUG_ADVICE_TYPE,
        true,
      )

      const dbSavedDrugs = await saveNewDrugs(
        drugAdviceToSave,
        clinicId,
        clinicBrandId,
        mentorProfileData?.id,
      )

      drugAdviceToSave = formNewInternalDrugObjectWithDrugAdviceItems({
        allDrugs: drugsAdvice,
        whatTimes: saveDrugWhatTime,
        durations: saveDrugDurations,
        notes: saveDrugNotes,
        frequencies: saveDrugFrequencies,
        dosages: saveDrugDosages,
        drugTypes: saveDrugType,
        prescriptionViewSettings,
      })

      const newHealthComplaints = await saveNewHealthEntities(
        selectedComplaints,
        HE_KEY_HEALTH_COMPLAINTS,
      )

      const newDiagnosisToSave = selectedDiagnosis?.filter((d) => !!d.label)

      const newDiagnosis = await saveNewHealthEntities(newDiagnosisToSave, HE_KEY_DIAGNOSIS)
      const newPsychAssessments = await saveNewHealthEntities(
        selectedAssessments,
        HE_KEY_PSYCH_ASSESSMENTS,
      )
      const newObservations = await saveNewHealthEntities(selectedObservations, HE_KEY_OBSERVATIONS)
      const newPrescritionAdvice = await saveNewHealthEntities(selectedAdvice, HE_KEY_ADVICE)
      const newInstructions = await saveNewHealthEntities(selectedInstructions, HE_KEY_INSTRUCTIONS)

      const _newInvestigations = await saveNewHealthEntities(
        selectedInvestigations,
        HE_KEY_INVESTIGATION,
        true,
      )

      newlySavedItems[HE_KEY_DRUGS] = dbSavedDrugs
      newlySavedItems[HE_KEY_HEALTH_COMPLAINTS] = newHealthComplaints
      newlySavedItems[HE_KEY_DIAGNOSIS] = newDiagnosis
      newlySavedItems[HE_KEY_OBSERVATIONS] = newObservations
      newlySavedItems[HE_KEY_ADVICE] = newPrescritionAdvice
      newlySavedItems[HE_KEY_INSTRUCTIONS] = newInstructions
      newlySavedItems[HE_KEY_PSYCH_ASSESSMENTS] = newPsychAssessments
      // newlySavedItems[HE_KEY_INVESTIGATION] = newInvestigations TODO: put these in the presc

      let body = {
        ...removeKeyFromObject(prescriptionData?.prescriptionData || {}),
        mentorId: mentorProfileData?.id,
        patientId: patientId,
        bookedEventId: eventId,
        content: value,
        prescriptionId: prescriptionId ? prescriptionId : '',
        drugInfoList: getDrugsListArrayForSubmission(
          drugAdviceToSave,
          clinicId,
          clinicBrandId,
          newlySavedItems,
        ),
        complaints: getHealthEntityArrayForSubmission(
          selectedComplaints,
          HE_KEY_HEALTH_COMPLAINTS,
          clinicId,
          clinicBrandId,
          newlySavedItems,
        ),
        diagnosis: getHealthEntityArrayForSubmission(
          newDiagnosisToSave,
          HE_KEY_DIAGNOSIS,
          clinicId,
          clinicBrandId,
          newlySavedItems,
        ),
        psychAssessments: getHealthEntityArrayForSubmission(
          selectedAssessments,
          HE_KEY_PSYCH_ASSESSMENTS,
          clinicId,
          clinicBrandId,
          newlySavedItems,
        ),
        investigations: getHealthEntityArrayForSubmission(
          selectedInvestigations,
          HE_KEY_INVESTIGATION,
          clinicId,
          clinicBrandId,
        ),
        healthObservations: getHealthEntityArrayForSubmission(
          selectedObservations,
          HE_KEY_OBSERVATIONS,
          clinicId,
          clinicBrandId,
          newlySavedItems,
        ),
        symptomsAndObservations: getHealthEntityArrayForSubmission(
          selectedObservations,
          HE_KEY_OBSERVATIONS,
          clinicId,
          clinicBrandId,
          newlySavedItems,
          true,
        ),
        prescriptionAdvices: getHealthEntityArrayForSubmission(
          selectedAdvice,
          HE_KEY_ADVICE,
          clinicId,
          clinicBrandId,
          newlySavedItems,
        ),

        guidanceAndAdvices: getHealthEntityArrayForSubmission(
          selectedAdvice,
          HE_KEY_ADVICE,
          clinicId,
          clinicBrandId,
          newlySavedItems,
          true,
        ),
        healthInstructions: getHealthEntityArrayForSubmission(
          selectedInstructions,
          HE_KEY_INSTRUCTIONS,
          clinicId,
          clinicBrandId,
          newlySavedItems,
        ),
        instructions: getHealthEntityArrayForSubmission(
          selectedInstructions,
          HE_KEY_INSTRUCTIONS,
          clinicId,
          clinicBrandId,
          newlySavedItems,
          true,
        ),
        therapiesNeeded: getSelectedTherapiesArrayForSubmission(selectedTherapies),
        finishRequestedTestsBy: finalRequestedTestsBy,
        requestedTherapist: selectedTherapist ? { uid: selectedTherapist?.value } : null,
        notesToTherapist: notesToTherapist,
        notesForAssessment: notesForAssessments,
        nextVisitDate: getNextVisitDateForSubmission(
          nextVisitInputValue,
          nextVisitInputType,
          undefined, // nextVisitCalendarInput (unused but maintains position)
          bookedEventInfo?.startTime, // Use bookedEventInfoStartTime for accurate calculation
        ),
        nextVisitTypeToShow: nextVisitInputType,
        referredToDoctorName: referredToDoctorName,
        templateId: prescriptionData?.id,
        suggestedBookingTherapy: suggestedBookingTherapy,
        uploadedImages: prescriptionData?.prescriptionData?.uploadedImages,
        qrCodeImageId: prescriptionData?.prescriptionData?.qrCodeImageId,
        prescriptionLanguages: prescriptionViewSettings?.preferredPrescriptionLanguages || ['en'],
      }
      if (isHomunculusValid(jointHomunculusData)) {
        body = {
          ...body,
          jointHomunculusData: {
            apiParam: 'joint-homunculus-data',
            ...jointHomunculusData,
          },
        }
      }
      if (freeFormRichText !== undefined) {
        body.freeFormRichText = freeFormRichText
      }
      const emrSectionDataListToSave = mergeFreeFormRichTextIntoEmrSectionDataList(
        emrSectionDataList,
        freeFormRichText || '',
      )
      const response = await postMPDataWithoutParams('/api/secure/doctor/prescription/save', {
        prescription: body,
        emrSectionDataList: emrSectionDataListToSave,
      })
      setPrescriptionSaveLoading(false)
      if (response.status === 200 && isCommonResponseSuccessfulV2(response)) {
        getRecommendedHealthEntityForDoctor()
        // Only refresh if not skipping (to avoid unnecessary API calls during print)
        if (!skipRefresh) {
          refreshPrescriptionData()
        }
        if (!!saveDrugType && saveDrugType?.length > 0)
          dispatch(
            fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_TYPE, force: true }),
          )
        if (!!saveDrugWhatTime && saveDrugWhatTime?.length > 0)
          dispatch(
            fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_TIMING, force: true }),
          )
        if (!!saveDrugFrequencies && saveDrugFrequencies?.length > 0)
          dispatch(
            fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_FREQUENCY, force: true }),
          )
        if (!!saveDrugDosages && saveDrugDosages?.length > 0)
          dispatch(
            fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_DOSAGE, force: true }),
          )
        if (!!saveDrugDurations && saveDrugDurations?.length > 0)
          dispatch(
            fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_DURATION, force: true }),
          )
        if (!!saveDrugNotes && saveDrugNotes?.length > 0)
          dispatch(fetchDrugAdviceEntity({ clinicBrandId, entity: HE_DRUG_ADVICE_NOTE }))
        // Only show toast if not suppressed (for background saves during PDF generation)
        if (!suppressToast) {
          toast.success('Signed and Saved Prescription', { autoClose: 2000 })
        }
      } else {
        const message = getErrorResponseFromErrorResponse(response)?.message
        const finalMessage = message
          ? `Couldn't save prescription: ${message}`
          : "Couldn't save prescription"
        toast.error(finalMessage, { autoClose: false })
      }
    }

    async function updateFinalPrice(_newPrice) {
      setPriceUpdateLoading(true)
      const body = {
        originalPrice: bookedEventInfo?.feePaid,
        discountedPrice: parseInt(discountedPriceOfSession),
        discountType: 'discountedPrice',
        patientId: patientId,
        mentorId: mentorProfileData?.id,
        bookedEventId: bookedEventInfo?.id,
      }
      const response = await postMPDataWithoutParams(
        `/api/secure/teacher/booked-event/discount-refund-initiate?bookedEventId=${bookedEventInfo?.id}`,
        body,
      )
      setPriceUpdateLoading(false)
      if (response.status === 200) {
        toast.success('Price Update Initiated', { autoClose: 2000 })
        if (
          isCommonResponseSuccessful(response?.data?.code) &&
          response?.data?.data?.discountAction?.discountedPrice
        ) {
          setBookedEventInfo((prev) => ({
            ...prev,
            discountAction: {
              discountedPrice: response?.data?.data?.discountAction?.discountedPrice,
            },
          }))
        }
      } else {
        toast.error("Couldn't update price.", { autoClose: false })
      }
    }

    const {
      saveAndPrint,
      quickPrint,
      saveAndPrintDirect,
      saveAndDownloadPDF,
      handleDownloadPDFFromDrawer,
      handleSendPDFToPatient,
    } = usePrintActions({
      pdfGenerating,
      setPdfGenerating,
      loadingToastIdRef,
      generateClientSidePDFForPrint,
      savePrescriptionData,
      colorMode,
      injectColorModeCSS,
      totalPages,
      setIsDownloadMode,
      setPdfDrawerOpen,
      setPdfProgressMessage,
      setShouldAutoPrint,
      setPdfBlob,
      setPdfUrl,
      setQuickPrintDrawerOpen,
      setClonedPagesHTML,
      pdfBlob,
      prescriptionData,
      printSettings,
      bookedEventInfo,
      drugsAdvice,
    })

    async function generateClientSidePDFForPrint(selectedPages = null, autoPrint = false, _loadingToastId = null) {
      return _generateClientSidePDFForPrint(selectedPages, autoPrint, _loadingToastId, {
        loadingToastIdRef,
        printSettings,
        savePrescriptionData,
        setIsDownloadMode,
        setPdfBlob,
        setPdfDrawerOpen,
        setPdfGenerating,
        setPdfProgressMessage,
        setPdfUrl,
        setShouldAutoPrint,
      })
    }

    async function getAndSetEmrSections() {
      dispatch(fetchEmrSections())
    }

    async function getRecommendedHealthEntityForDoctor() {
      dispatch(getDoctorRecommendedHealthEntities({ clinicBrandId }))
    }

    const categoriesListFromStore = useSelector(selectCategoriesList)

    async function putCategoriesInStoreIfNeeded() {
      if (categoriesListFromStore === null) {
        const response = await getDataWithParams('/api/external/app-listable/list', {
          feature: 'categories',
        })
        if (response?.status === 200 && Array.isArray(response?.data)) {
          dispatch(setCategoriesList(response?.data))
        }
      }
    }

    function _renderLastPageForDocOnLayout() {
      return (
        <DoconPageItemsContainer>
          <DoconPageSingleItemContainer style={{ borderRight: '1px solid #000' }}>
            <DoconPageSingleItemContainer>
              {emrSections?.find((item) => item?.id === 'next_visit_details')?.selected && (
                <>{nextVisitDetailsSection(bookedEventInfo)}</>
              )}
              {emrSections?.find((item) => item?.id === 'therapy_recommendation')?.selected && (
                <>{renderTherapyRecommendationSection()}</>
              )}
              {emrSections?.find((item) => item?.id === 'payment_and_refund')?.selected && (
                <>{renderPayemntAndRefundSection()}</>
              )}
            </DoconPageSingleItemContainer>
          </DoconPageSingleItemContainer>
          <DoconPageSingleItemContainer>
            {renderPrescriptionView({ showInUI: true })}
          </DoconPageSingleItemContainer>
        </DoconPageItemsContainer>
      )
    }

    // Hide any "Page 1" or "Page X of Y" labels that appear
    useEffect(() => {
      // Optimized function to hide page labels - only check visible positioned elements
      const hidePageLabels = () => {
        // Only check elements that are likely to be page labels (positioned elements)
        // This is much more efficient than querying all elements
        const positionedElements = document.querySelectorAll('[style*="position: absolute"], [style*="position:fixed"], [style*="position: absolute"], [style*="position:fixed"]')
        
        positionedElements.forEach((el) => {
          // Skip if already hidden
          if (el.style.display === 'none' || el.style.visibility === 'hidden') {
            return
          }
          
          const text = el.textContent || ''
          // Check if element contains page number patterns
          if (
            text.match(/^Page\s+1\s*$/i) || 
             text.match(/^Page\s+\d+\s*$/i) ||
            text.match(/Page\s+\d+\s+of\s+\d+/i)
          ) {
            const computedStyle = window.getComputedStyle(el)
            if (computedStyle.position === 'absolute' || computedStyle.position === 'fixed') {
            // Hide the element
            el.style.display = 'none'
            el.style.visibility = 'hidden'
            el.style.opacity = '0'
            el.style.height = '0'
            el.style.width = '0'
            el.style.overflow = 'hidden'
            }
          }
        })
      }

      // Run immediately
      hidePageLabels()

      // Use MutationObserver to catch dynamically added elements
      // Use debouncing to avoid excessive calls
      let mutationTimeout = null
      const handleMutation = () => {
        if (mutationTimeout) {
          clearTimeout(mutationTimeout)
        }
        mutationTimeout = setTimeout(() => {
          hidePageLabels()
        }, 100) // Debounce mutations
      }
      
      const observer = new MutationObserver(handleMutation)
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['style'] // Only watch style changes
      })

      // Run periodically as a fallback (less frequently to reduce CPU usage)
      const interval = setInterval(hidePageLabels, 3000) // Reduced from 1000ms to 3000ms

      return () => {
        observer.disconnect()
        clearInterval(interval)
        if (mutationTimeout) {
          clearTimeout(mutationTimeout)
        }
      }
    }, [])

    const _prescriptionViewSharedProps = {
      allVitalsOfThisPatient,
      bookedEventInfo,
      colorMode,
      drugsAdvice,
      emrSections,
      emrSectionsToShowInOrder,
      finalRequestedTestsBy,
      freeFormRichText,
      jointHomunculusData,
      nextVisitInputType,
      nextVisitInputValue,
      patientHistoryNotes,
      prescriptionData,
      prescriptionViewSettings,
      printSettings,
      referredToDoctorName,
      selectedAdvice,
      selectedAssessments,
      selectedComplaints,
      selectedDiagnosis,
      selectedInstructions,
      selectedInvestigations,
      selectedObservations,
      selectedTherapies,
      suggestedBookingTherapy,
      setTotalPages,
      setPrintSettings,
      setPrescriptionData,
      setValue,
      setPropValue,
      DEBUG_MODE,
      isPrintingPastHistoryReports,
      printType,
      honorPropValue,
      value,
      handleColorModeChange: _handleColorModeChange,
    }

    function renderPrescriptionView({ showInUI }) {
      return (
        <PrescriptionViewWithPrintCSS
          showInUI={showInUI}
          {..._prescriptionViewSharedProps}
        />
      )
    }

    function renderSectionForDocon(sectionId, idxInPage) {
      return _renderSectionForDoconImported(sectionId, idxInPage, {
        emrSectionsToShowInOrder,
        screeningSections,
        screeningReportTemplateData,
        bookedEventInfo,
        mentorProfileData,
        setPatientHistoryNotes,
        patientHistoryNotesRef,
        auxiliaryDataFromProps,
        emrSectionsEditorDialogHandleOpen,
        emrSections,
        freeFormRichText,
        setFreeFormRichText,
        screeningReportData,
        screeningReportVisible,
        setScreeningReportVisible,
        setScreeningReportData,
        clinicId,
        clinicBrandId,
        selectedObservations,
        setSelectedObservations,
        prescriptionViewSettings,
        recommendedHealthEntityForDoctor,
        selectedComplaints,
        setSelectedComplaints,
        selectedDiagnosis,
        setSelectedDiagnosis,
        jointHomunculusData,
        setJointHomunculusData,
        drugAdviceTypes,
        drugAdviceDurations,
        drugAdviceFrequencies,
        drugAdviceNotes,
        drugAdviceWhatTimeOptions,
        drugAdviceDosages,
        drugsAdvice,
        handleAddDrugAdviceItem,
        handleDrugAdviceChange,
        handleDeleteDrugAdviceItem,
        setDrugsAdvice,
        selectedInvestigations,
        setSelectedInvestigations,
        openInvestigationForm,
        showInvestigationForm,
        closeInvestigationForm,
        submitInvestigation,
        initialInvestigationObjectToEdit,
        investigationToEdit,
        setInvestigationToEdit,
        setSavingInvestigation,
        handleChangeInvestigationToEdit,
        investigationTitleValid,
        setInvestigationTitleValid,
        categoriesListFromStore,
        sampleTypes,
        savingInvestigation,
        confirmationModalProps,
        selectedAdvice,
        setSelectedAdvice,
        selectedInstructions,
        setSelectedInstructions,
        eventId,
        prescriptionData,
        setPrescriptionData,
        SectionPrintIndicator,
        nextVisitDetailsSection,
        renderPatientVitals,
        renderPrivateNotesSection,
        renderReferToSection,
        renderObservations,
        renderHealthComplaints,
        renderDiagnosis,
        renderJointHomunculus,
        renderDrugAdvice,
        renderInvestigations,
        renderAdvice,
        renderInstructions,
        renderPayemntAndRefundSection,
        renderTherapyRecommendationSection,
        renderPsychAssessmentSelection,
        renderSignatureSection,
        renderPrescriptionView,
      })
    }

    function renderSectionForHP(sectionId) {
      return _renderSectionForHPImported(sectionId, {
        emrSectionsToShowInOrder,
        screeningReportData,
        auxiliaryDataFromProps,
        emrSectionDataList,
        setEmrSectionDataList,
        patientHistoryNotesRef,
        setPatientHistoryNotes,
        bookedEventInfo,
        emrSectionsEditorDialogHandleOpen,
        patientHistoryEmrData,
        setPatientHistoryEmrData,
        emrSections,
        freeFormRichText,
        setFreeFormRichText,
        screeningReportVisible,
        setScreeningReportVisible,
        setScreeningReportData,
        mentorProfileData,
        screeningSections,
        screeningReportTemplateData,
        eventId,
        patientId,
        clinicId,
        prescriptionData,
        setPrescriptionData,
        SectionPrintIndicator,
        nextVisitDetailsSection,
        renderSignatureSection,
        renderPatientVitals,
        renderObservations,
        renderHealthComplaints,
        renderDiagnosis,
        renderJointHomunculus,
        renderDrugAdvice,
        renderInvestigations,
        renderAdvice,
        renderInstructions,
        renderPayemntAndRefundSection,
        renderPrivateNotesSection,
        renderReferToSection,
        renderTherapyRecommendationSection,
        renderPsychAssessmentSelection,
      })
    }

    const {
      nextVisitDetailsSection,
      renderSignatureSection,
      renderPatientVitals,
      renderObservations,
      renderHealthComplaints,
      renderDiagnosis,
      renderJointHomunculus,
      renderDrugAdvice,
      renderInvestigations,
      renderAdvice,
      renderInstructions,
      renderPayemntAndRefundSection,
      renderPrivateNotesSection,
      renderReferToSection,
      renderTherapyRecommendationSection,
      renderPsychAssessmentSelection,
      renderSectionForDoconLayout,
    } = createPrescriptionSectionRenderers({
      SectionPrintIndicator,
      emrSectionsToShowInOrder,
      nextVisitInputValue,
      setNextVisitInputValue,
      nextVisitInputType,
      setNextVisitInputType,
      mentorProfileData,
      roomId,
      patientId,
      clinicId,
      clinicBrandId,
      getProcessAndSetEventData,
      showNextVisitSlotSelector,
      savePrescriptionData,
      keepSectionStateBeforeClearAll,
      undoClearAllChangeInPrescription,
      printSettings,
      prescriptionData,
      prescriptionViewSettings,
      vitalsRef,
      emrSectionsEditorDialogHandleOpen,
      bookedEventInfo,
      allVitalsOfThisPatient,
      setAllVitalsOfThisPatient,
      selectedObservations,
      setSelectedObservations,
      recommendedHealthEntityForDoctor,
      selectedComplaints,
      setSelectedComplaints,
      selectedDiagnosis,
      setSelectedDiagnosis,
      jointHomunculusData,
      setJointHomunculusData,
      drugsAdvice,
      setDrugsAdvice,
      drugAdviceTypes,
      drugAdviceDosages,
      drugAdviceWhatTimeOptions,
      drugAdviceFrequencies,
      drugAdviceDurations,
      drugAdviceNotes,
      handleAddDrugAdviceItem,
      handleDrugAdviceChange,
      handleDeleteDrugAdviceItem,
      selectedInvestigations,
      setSelectedInvestigations,
      openInvestigationForm,
      showInvestigationForm,
      closeInvestigationForm,
      submitInvestigation,
      initialInvestigationObjectToEdit,
      investigationToEdit,
      setInvestigationToEdit,
      setSavingInvestigation,
      handleChangeInvestigationToEdit,
      investigationTitleValid,
      setInvestigationTitleValid,
      sampleTypes,
      savingInvestigation,
      selectedAdvice,
      setSelectedAdvice,
      selectedInstructions,
      setSelectedInstructions,
      ensureEmptyRowsForTables,
      referredToDoctorName,
      setReferredToDoctorName,
      choseToGiveDiscount,
      discountedPriceOfSession,
      setChoseToGiveDiscount,
      setDiscountedPriceOfSession,
      updateFinalPrice,
      priceUpdateLoading,
      finalRequestedTestsBy,
      setFinalRequestedTestsBy,
      newTestAnchor,
      setNewTestAnchor,
      categoriesListFromStore,
      notesRef,
      selectedTherapies,
      setSelectedTherapies,
      attachPrescriptionForTherapy,
      setAttachPrescriptionForTherapy,
      suggestedBookingTherapy,
      notesToTherapist,
      setNotesToTherapist,
      selectedAssessments,
      setSelectedAssessments,
      attachPrescriptionForAssessments,
      setAttachPrescriptionForAssessments,
      notesForAssessments,
      setNotesForAssessments,
      renderSectionForDocon,
      HE_KEY_OBSERVATIONS,
      HE_KEY_HEALTH_COMPLAINTS,
      HE_KEY_DIAGNOSIS,
      HE_KEY_INVESTIGATION,
      HE_KEY_ADVICE,
      HE_KEY_INSTRUCTIONS,
      Card,
      CardContent,
      Box,
      Typography,
      FormControlLabel,
      Checkbox,
      TextareaAutosize,
      CalendarToday,
      Assignment,
      Warning,
      Healing,
      LocalPharmacy,
      Science,
      TipsAndUpdates,
      MenuBook,
      BadgeIcon,
      Psychology,
      AttachMoney,
      CircularProgress,
      Popover,
      Dialog,
      DialogActions,
      DialogContent,
      DialogTitle,
      Button,
      SignatureComponent,
      VitalsComponentInlineEntryComponent,
      ObservationsInputComponent,
      HealthComplaintsInputComponent,
      DiagnosisSelectMenu,
      JointHomunculusComponent,
      DrugAdviceInput,
      InvestigationsSelectMenu,
      AdviceInputComponent,
      EMRInstructionsInput,
      PrivateNotesSection,
      SuggestedTherapySelectMenu,
      SuggestedAssessmentsSelectMenu,
      EMRNextVisitComponent,
      CancelAndRedoComponent,
      AddNewTestComponent,
      InvestigationForm,
      getPriceStringWithCurrency,
      convertAssessmentIdBasedCategoryListToMetaCategoryList,
      isHomunculusValid,
      PMPSectionInputBox,
      DoconPageItemsContainer,
      DoconPageSingleItemContainer,
    })
    const drugAdviceSubSections = emrSectionsToShowInOrder?.find(
      (item) => item?.id === 'drug_advice',
    )?.subSections

    function previousSection() {
      //remove the last item is the current page history
      setCurrentPageHistory((prev) => (prev || [])?.slice(0, prev.length - 1))
    }

    function goToPrintPage() {
      setCurrentPageHistory((prev) => {
        //find index of the View/Print Prescription section, then put its previous index in the history
        const idx = emrSectionsToShowInOrderForDocOn.findIndex(
          (item) => item?.id === 'prescription',
        )
        return [...(prev || []), idx - 1]
      })
    }

    function nextSection() {
      //+ 2 from the last item in the current page history. If there is no last item, its 0 + 2
      setCurrentPageHistory((prev) => {
        const lastItem = prev?.[prev.length - 1]
        return [...(prev || []), lastItem ? lastItem + 2 : 2]
      })
    }

    useEffect(() => {
      getAndSetEmrSections()
      getRecommendedHealthEntityForDoctor()
      // Fetch settings with 'prescription' report type (default)
      dispatch(fetchPrescriptionViewSettings({ emrReportType: 'prescription' }))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    // Re-fetch settings when Redux store updates (in case settings were saved from another component)
    useEffect(() => {
      // This will re-fetch if the store state changes, ensuring we have the latest settings
      if (prescrpitionViewSettingsStoreData?.state === 'idle' && !prescrpitionViewSettingsStoreData?.data) {
        dispatch(fetchPrescriptionViewSettings({ emrReportType: 'prescription' }))
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prescrpitionViewSettingsStoreData?.state])

    useEffect(() => {
      if (selectedTherapies?.length > 0) {
        setSuggestedBookingTherapy(true)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTherapies])

    useEffect(() => {
      if (selectedTherapies?.length > 0 && attachPrescriptionForTherapy === undefined) {
        setAttachPrescriptionForTherapy(true)
      }
    }, [selectedTherapies, attachPrescriptionForTherapy, setAttachPrescriptionForTherapy])

    useEffect(() => {
      if (selectedAssessments?.length > 0 && attachPrescriptionForAssessments === undefined) {
        setAttachPrescriptionForAssessments(true)
      }
    }, [selectedAssessments, attachPrescriptionForAssessments, setAttachPrescriptionForAssessments])

    // Listen for navigation events from history drawer
    useEffect(() => {
      const handlePrescriptionNavigate = (event) => {
        const { section, action } = event.detail || {}
        if (section === 'therapy_recommendation' && action === 'selectTherapy') {
          // Auto-select therapy checkbox
          setSuggestedBookingTherapy(true)
          // Scroll to section
          setTimeout(() => {
            const therapySection = document.querySelector('[data-section-id="therapy_recommendation"]')
            if (therapySection) {
              therapySection.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 100)
        } else if (section === 'psych_assessments' && action === 'selectAssessment') {
          // Scroll to assessment section
          setTimeout(() => {
            const assessmentSection = document.querySelector('[data-section-id="psych_assessments"]')
            if (assessmentSection) {
              assessmentSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 100)
        }
      }

      window.addEventListener('prescription-navigate', handlePrescriptionNavigate)
      return () => {
        window.removeEventListener('prescription-navigate', handlePrescriptionNavigate)
      }
    }, [setSuggestedBookingTherapy])

    // Handle navigation from sessionStorage (when coming from drawer on different page)
    useEffect(() => {
      const scrollToSection = sessionStorage.getItem('prescriptionScrollToSection')
      const action = sessionStorage.getItem('prescriptionAction')
      
      if (scrollToSection) {
        // Wait for page to fully load
        setTimeout(() => {
          const section = document.querySelector(`[data-section-id="${scrollToSection}"]`)
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' })
            // Handle actions
            if (action === 'selectTherapy' && scrollToSection === 'therapy_recommendation') {
              setSuggestedBookingTherapy(true)
            }
          }
          // Clear sessionStorage
          sessionStorage.removeItem('prescriptionScrollToSection')
          sessionStorage.removeItem('prescriptionAction')
        }, 1000) // Wait for page to load
      }
    }, [eventId, setSuggestedBookingTherapy]) // Re-run when eventId changes (page loads)

    useEffect(() => {
      putCategoriesInStoreIfNeeded()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      getInvestigationSamples()
      // putAllDrugsInDB()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // useEffect(() => {
    //   saveTriggerFunction()
    // }, [triggerSave])

    useEffect(() => {
      ensureEmptyRowsForTables()
    }, [drugsAdvice, selectedDiagnosis, emrSections, ensureEmptyRowsForTables])

    useEffect(() => {
      if (moveToPrintPrescriptionScreen && !loadingEmrSections) {
        goToPrintPage()
        setMoveToPrintPrescriptionScreen(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moveToPrintPrescriptionScreen, loadingEmrSections])

    // Trigger print from the drawer after it's opened and content is rendered
    useEffect(() => {
      if (!quickPrintDrawerOpen) {
        return
      }
      
      console.log('[PrescriptionMakingPage] Quick print drawer opened, waiting for content to render...')
      
      // Wait for drawer animation to complete and content to render
      // Material-UI Drawer has a default transition of 225ms, so we wait longer
      const checkAndPrint = () => {
        // Check if container exists and has content
        if (!quickPrintContainerRef.current) {
          console.log('[PrescriptionMakingPage] Container ref not ready, retrying...')
          window.setTimeout(checkAndPrint, 100)
          return
        }
        
        // Check if content is actually rendered
        const container = quickPrintContainerRef.current
        if (!container.innerHTML || container.innerHTML.trim() === '') {
          console.log('[PrescriptionMakingPage] Container content not ready, retrying...')
          window.setTimeout(checkAndPrint, 100)
          return
        }
        
        // Check if all prescription pages are in the DOM
        const pagesInContainer = container.querySelectorAll('.prescription-page')
        console.log(`[PrescriptionMakingPage] Found ${pagesInContainer.length} pages in container`)
        
        if (pagesInContainer.length === 0) {
          console.log('[PrescriptionMakingPage] No pages found in container, retrying...')
          window.setTimeout(checkAndPrint, 100)
          return
        }
        
        console.log('[PrescriptionMakingPage] Container ready, injecting print CSS and triggering print...')
        
        // Inject print CSS
        const printStyleId = 'rx-quick-print-drawer-style'
        let existingPrintStyle = document.getElementById(printStyleId)
        if (existingPrintStyle) {
          existingPrintStyle.remove()
        }
        
        const printStyle = document.createElement('style')
        printStyle.id = printStyleId
        const currentDpiData = A4DpiToDetailsMap?.[printSettings?.dpi] || A4DpiToDetailsMap[96]
        const widthOfA4Page = currentDpiData?.width || 794
        
          printStyle.textContent = `
          ${colorMode === 'bw' 
            ? `
              @media print {
                * {
                  -webkit-print-color-adjust: economy !important;
                  print-color-adjust: economy !important;
                  color-adjust: economy !important;
                }
                body {
                  filter: grayscale(100%) !important;
                  -webkit-filter: grayscale(100%) !important;
                }
              }
            `
            : `
              @media print {
                * {
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                  color-adjust: exact !important;
                }
              }
            `
          }
          @media print {
            /* Print only quick-print drawer content; avoid global print rules from other surfaces */
            body * {
              visibility: hidden !important;
            }
            /* Hide all body children from layout flow */
            body > * {
              display: none !important;
            }
            /* Keep only detached print root in flow */
            body > [data-quick-print-detached-root] {
              display: block !important;
              visibility: visible !important;
              position: static !important;
              margin: 0 !important;
              padding: 0 !important;
              page-break-before: auto !important;
              break-before: auto !important;
            }
            .quick-print-drawer-root,
            .quick-print-drawer-root *,
            [data-quick-print-detached-root],
            [data-quick-print-detached-root] * {
              visibility: visible !important;
            }
            /* In detached-root mode, suppress drawer subtree to avoid duplicate pages */
            .quick-print-drawer-root,
            .quick-print-drawer-root * {
              visibility: hidden !important;
            }
            .quick-print-drawer-root {
              display: none !important;
              height: 0 !important;
              max-height: 0 !important;
              overflow: hidden !important;
            }
            .quick-print-drawer-root {
              position: static !important;
              inset: auto !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              background: white !important;
            }
            [data-quick-print-detached-root] {
              display: block !important;
              visibility: visible !important;
              position: static !important;
              inset: auto !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              background: white !important;
            }
            /* Hide every prescription page by default in print to prevent cross-surface duplication */
            .prescription-page {
              display: none !important;
              visibility: hidden !important;
            }
            /* Re-enable only detached-root pages for printing */
            [data-quick-print-detached-root] .prescription-page {
              display: block !important;
              visibility: visible !important;
            }
            /* Keep drawer paper visible in print; global print CSS elsewhere hides MuiDrawer* */
            html body .quick-print-drawer-root .MuiDrawer-paper,
            html body .quick-print-drawer-root [class*="MuiDrawer-paper"] {
              display: block !important;
              visibility: visible !important;
              position: static !important;
              height: auto !important;
              min-height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              overflow-x: visible !important;
              overflow-y: visible !important;
              box-shadow: none !important;
              transform: none !important;
            }
            .quick-print-container,
            .quick-print-container * {
              visibility: visible !important;
            }
            .quick-print-container {
              position: static !important;
              inset: auto !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              background: white !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            /* Reset all containers to show all content */
            html, body {
              margin: 0 !important;
              padding: 0 !important;
              width: 100% !important;
              height: auto !important;
              min-height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              overflow-x: visible !important;
              overflow-y: visible !important;
              background: white !important;
            }
            /* Make drawer and all containers visible - critical for showing all pages */
            .MuiDrawer-root,
            .MuiDrawer-paper,
            .MuiModal-root,
            .MuiBackdrop-root,
            [class*="MuiDrawer"],
            [class*="MuiPaper"] {
              position: static !important;
              height: auto !important;
              min-height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              overflow-x: visible !important;
              overflow-y: visible !important;
              display: block !important;
            }
            .quick-print-container {
              width: 100% !important;
              height: auto !important;
              min-height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              overflow-x: visible !important;
              overflow-y: visible !important;
              display: block !important;
              position: static !important;
            }
            /* Ensure all prescription pages are visible and properly styled */
            .quick-print-container .prescription-page,
            [data-quick-print-detached-root] .prescription-page {
              display: block !important;
              visibility: visible !important;
              opacity: 1 !important;
              page-break-inside: avoid !important;
              page-break-after: always !important;
              break-after: page !important;
              page-break-before: auto !important;
              margin: 0 auto !important;
              padding: 0 !important;
              width: ${widthOfA4Page}px !important;
              max-width: ${widthOfA4Page}px !important;
              min-width: ${widthOfA4Page}px !important;
              height: auto !important;
              min-height: auto !important;
              max-height: none !important;
              box-sizing: border-box !important;
              position: relative !important;
              clear: both !important;
              float: none !important;
            }
            /* Last page should not have page break after */
            .quick-print-container .prescription-page:last-child,
            [data-quick-print-detached-root] .prescription-page:last-child {
              page-break-after: auto !important;
              break-after: auto !important;
            }
            /* Remove padding/margins from A4 containers in print */
            .quick-print-container .prescription-page .A4PageContainer,
            .quick-print-container .prescription-page .A4PageMeasureComponentWrapperContainer,
            .quick-print-container .prescription-page [id^="a4-"],
            [data-quick-print-detached-root] .prescription-page .A4PageContainer,
            [data-quick-print-detached-root] .prescription-page .A4PageMeasureComponentWrapperContainer,
            [data-quick-print-detached-root] .prescription-page [id^="a4-"] {
              padding: 0 !important;
              margin: 0 !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 100% !important;
              box-sizing: border-box !important;
              height: auto !important;
              overflow: visible !important;
            }
            /* Ensure all elements respect page width */
            .quick-print-container .prescription-page *,
            [data-quick-print-detached-root] .prescription-page * {
              max-width: 100% !important;
              box-sizing: border-box !important;
            }
            /* Ensure tables are visible and properly styled */
            table {
              display: table !important;
              visibility: visible !important;
              opacity: 1 !important;
              width: 100% !important;
              border-collapse: collapse !important;
              page-break-inside: avoid !important;
              margin: 0 !important;
              padding: 0 !important;
            }
            table tr {
              display: table-row !important;
              visibility: visible !important;
              opacity: 1 !important;
            }
            table td,
            table th {
              display: table-cell !important;
              visibility: visible !important;
              opacity: 1 !important;
            }
            /* Ensure blank header space is preserved and visible - use rectangle approach */
            /* Height values are set via inline styles from JavaScript - don't hardcode here */
            .quick-print-container .prescription-page .blank-header-space,
            .quick-print-container .prescription-page div[data-header-height],
            .quick-print-container .prescription-page div.blank-header-space,
            [data-quick-print-detached-root] .prescription-page .blank-header-space,
            [data-quick-print-detached-root] .prescription-page div[data-header-height],
            [data-quick-print-detached-root] .prescription-page div.blank-header-space {
              display: block !important;
              visibility: visible !important;
              opacity: 1 !important;
              /* height, min-height, max-height, and flex-basis are set via inline styles */
              /* Fallback minimum height to ensure visibility if inline style is missing or 0 */
              min-height: 120px !important;
              width: 100% !important;
              overflow: hidden !important;
              box-sizing: border-box !important;
              flex-shrink: 0 !important;
              flex-grow: 0 !important;
              /* flex-basis is set via inline styles */
              background-color: transparent !important;
              border: none !important;
              margin: 0 !important;
              padding: 0 !important;
              position: relative !important;
            }
            /* Ensure the invisible spacer inside is preserved */
            /* Height is set via inline styles from JavaScript */
            .quick-print-container .prescription-page .blank-header-space > span,
            [data-quick-print-detached-root] .prescription-page .blank-header-space > span {
              display: inline-block !important;
              /* height is set via inline styles */
              width: 1px !important;
              opacity: 0 !important;
              visibility: hidden !important;
              position: absolute !important;
            }
            /* Ensure PmpHeaderContainer preserves blank space */
            .quick-print-container .prescription-page [class*="PmpHeaderContainer"],
            [data-quick-print-detached-root] .prescription-page [class*="PmpHeaderContainer"] {
              display: flex !important;
              flex-direction: column !important;
            }
            /* Prevent blank header space from being collapsed by flex */
            .quick-print-container .prescription-page [class*="PmpHeaderContainer"] > .blank-header-space,
            [data-quick-print-detached-root] .prescription-page [class*="PmpHeaderContainer"] > .blank-header-space {
              /* flex-basis, height, min-height, max-height are set via inline styles */
              width: 100% !important;
              flex-shrink: 0 !important;
              flex-grow: 0 !important;
            }
            @page {
              size: A4;
              orientation: portrait;
              margin: 0;
              -webkit-print-color-adjust: ${colorMode === 'bw' ? 'economy' : 'exact'} !important;
              print-color-adjust: ${colorMode === 'bw' ? 'economy' : 'exact'} !important;
              color-adjust: ${colorMode === 'bw' ? 'economy' : 'exact'} !important;
            }
          }
        `
        document.head.appendChild(printStyle)
        
        // Force all pages to be visible and properly sized before printing
        // Remove height constraints from container and ensure all pages are visible
        const originalContainerStyle = {
          height: container.style.height,
          maxHeight: container.style.maxHeight,
          minHeight: container.style.minHeight,
          overflow: container.style.overflow,
          overflowY: container.style.overflowY,
        }
        const tempStyleChanges = []
        const setTempStyle = (el, prop, value, priority = '') => {
          if (!el || !el.style) return
          tempStyleChanges.push({
            el,
            prop,
            prevValue: el.style.getPropertyValue(prop),
            prevPriority: el.style.getPropertyPriority(prop),
          })
          el.style.setProperty(prop, value, priority)
        }
        // Make container show all content
        container.style.height = 'auto'
        container.style.maxHeight = 'none'
        container.style.minHeight = 'auto'
        container.style.overflow = 'visible'
        container.style.overflowY = 'visible'
        
        // Ensure all pages are visible and properly styled
        const pages = container.querySelectorAll('.prescription-page')
        const firstPageEl = pages?.[0] || null
        const secondPageEl = pages?.[1] || null
        const snapshotBreak = (el) => {
          if (!el) return null
          const cs = window.getComputedStyle(el)
          return {
            className: el.className || null,
            display: cs.display,
            visibility: cs.visibility,
            pageBreakAfter: cs.pageBreakAfter || null,
            pageBreakBefore: cs.pageBreakBefore || null,
            breakAfter: cs.breakAfter || null,
            breakBefore: cs.breakBefore || null,
            height: cs.height || null,
            minHeight: cs.minHeight || null,
            maxHeight: cs.maxHeight || null,
            rect: (() => {
              const r = el.getBoundingClientRect()
              return { x: r.x, y: r.y, w: r.width, h: r.height }
            })(),
          }
        }
        const snapshotHeader = (pageEl) => {
          if (!pageEl) return null
          const h = pageEl.querySelector('[data-print-header="true"]')
          if (!h) return { exists: false }
          const cs = window.getComputedStyle(h)
          return {
            exists: true,
            display: cs.display,
            visibility: cs.visibility,
            height: cs.height,
            textLen: (h.textContent || '').trim().length,
          }
        }
        const snapshotA4Root = (pageEl) => {
          if (!pageEl) return null
          const a4 = pageEl.querySelector('[id^="a4-"]')
          if (!a4) return { exists: false }
          const cs = window.getComputedStyle(a4)
          return {
            exists: true,
            id: a4.id || null,
            position: cs.position || null,
            display: cs.display || null,
            visibility: cs.visibility || null,
            overflow: cs.overflow || null,
            height: cs.height || null,
            minHeight: cs.minHeight || null,
            maxHeight: cs.maxHeight || null,
            absoluteDescendantCount: a4.querySelectorAll('[style*="position: absolute"], [style*="position:absolute"]').length,
          }
        }
        const snapshotContainerChain = () => {
          const drawerRoot = document.querySelector('.quick-print-drawer-root')
          const drawerPaper = drawerRoot?.querySelector('.MuiDrawer-paper') || null
          const rootBox = container?.closest('.MuiBox-root') || null
          const pick = (el) => {
            if (!el) return null
            const cs = window.getComputedStyle(el)
            return {
              className: el.className || null,
              display: cs.display || null,
              position: cs.position || null,
              height: cs.height || null,
              minHeight: cs.minHeight || null,
              maxHeight: cs.maxHeight || null,
              overflow: cs.overflow || null,
              overflowY: cs.overflowY || null,
              visibility: cs.visibility || null,
            }
          }
          return {
            drawerRoot: pick(drawerRoot),
            drawerPaper: pick(drawerPaper),
            rootBox: pick(rootBox),
            container: pick(container),
          }
        }
        const snapshotGlobalPages = () => {
          const allPages = Array.from(document.querySelectorAll('.prescription-page'))
          const drawerPages = Array.from(container.querySelectorAll('.prescription-page'))
          const detachedRoot = document.querySelector('[data-quick-print-detached-root]')
          const detachedPages = detachedRoot
            ? Array.from(detachedRoot.querySelectorAll('.prescription-page'))
            : []
          const drawerSet = new Set(drawerPages)
          const detachedSet = new Set(detachedPages)
          const outsidePages = allPages.filter((el) => !drawerSet.has(el) && !detachedSet.has(el))
          const isVisible = (el) => {
            if (!el) return false
            const cs = window.getComputedStyle(el)
            return cs.display !== 'none' && cs.visibility !== 'hidden' && Number.parseFloat(cs.opacity || '1') !== 0
          }
          return {
            allPagesCount: allPages.length,
            drawerPagesCount: drawerPages.length,
            detachedPagesCount: detachedPages.length,
            outsidePagesCount: outsidePages.length,
            drawerVisiblePagesCount: drawerPages.filter(isVisible).length,
            detachedVisiblePagesCount: detachedPages.filter(isVisible).length,
            outsideVisiblePagesCount: outsidePages.filter(isVisible).length,
            drawerA4Ids: drawerPages.map((p) => p.querySelector('[id^="a4-"]')?.id).filter(Boolean).slice(0, 10),
            detachedA4Ids: detachedPages.map((p) => p.querySelector('[id^="a4-"]')?.id).filter(Boolean).slice(0, 10),
            outsideA4Ids: outsidePages.map((p) => p.querySelector('[id^="a4-"]')?.id).filter(Boolean).slice(0, 10),
          }
        }
        const hideNonDetachedPagesForPrint = () => {
          const _detachedRoot = document.getElementById(detachedRootId)
          const _detachedPages = _detachedRoot
            ? Array.from(_detachedRoot.querySelectorAll('.prescription-page'))
            : []
          if (_detachedPages.length === 0) {
            return
          }
          const _detachedSet = new Set(_detachedPages)
          const _allPages = Array.from(document.querySelectorAll('.prescription-page'))
          const _toHide = _allPages.filter((el) => !_detachedSet.has(el))
          _toHide.forEach((el) => {
            setTempStyle(el, 'display', 'none', 'important')
            setTempStyle(el, 'visibility', 'hidden', 'important')
            setTempStyle(el, 'opacity', '0', 'important')
            setTempStyle(el, 'height', '0px', 'important')
            setTempStyle(el, 'min-height', '0px', 'important')
            setTempStyle(el, 'max-height', '0px', 'important')
            setTempStyle(el, 'overflow', 'hidden', 'important')
            const a4 = el.querySelector('[id^="a4-"]')
            if (a4) {
              setTempStyle(a4, 'display', 'none', 'important')
              setTempStyle(a4, 'visibility', 'hidden', 'important')
              setTempStyle(a4, 'opacity', '0', 'important')
              setTempStyle(a4, 'height', '0px', 'important')
              setTempStyle(a4, 'min-height', '0px', 'important')
              setTempStyle(a4, 'max-height', '0px', 'important')
              setTempStyle(a4, 'overflow', 'hidden', 'important')
            }
          })
        }

        const onDrawerBeforePrint = () => {
          hideNonDetachedPagesForPrint()
          const _pagesAtPrint = Array.from(container.querySelectorAll('.prescription-page'))
          const _detachedRootAtPrint = document.getElementById(detachedRootId)
          const _detachedPagesAtPrint = _detachedRootAtPrint
            ? Array.from(_detachedRootAtPrint.querySelectorAll('.prescription-page'))
            : []
          const _detachedRootStyle = _detachedRootAtPrint
            ? window.getComputedStyle(_detachedRootAtPrint)
            : null
          window.removeEventListener('beforeprint', onDrawerBeforePrint)
        }
        window.addEventListener('beforeprint', onDrawerBeforePrint)
        const printMq = window.matchMedia ? window.matchMedia('print') : null
        const onDrawerPrintChange = (evt) => {
          const _pagesAtChange = Array.from(container.querySelectorAll('.prescription-page'))
          const _detachedRootAtChange = document.getElementById(detachedRootId)
          const _detachedPagesAtChange = _detachedRootAtChange
            ? Array.from(_detachedRootAtChange.querySelectorAll('.prescription-page'))
            : []
          const _detachedRootStyle = _detachedRootAtChange
            ? window.getComputedStyle(_detachedRootAtChange)
            : null
          if (!evt?.matches && printMq?.removeEventListener) {
            printMq.removeEventListener('change', onDrawerPrintChange)
          }
        }
        if (printMq?.addEventListener) {
          printMq.addEventListener('change', onDrawerPrintChange)
        }

        const detachedRootId = 'quick-print-detached-root'
        const existingDetached = document.getElementById(detachedRootId)
        if (existingDetached) {
          existingDetached.remove()
        }
        const detachedRoot = document.createElement('div')
        detachedRoot.id = detachedRootId
        detachedRoot.setAttribute('data-quick-print-detached-root', 'true')
        detachedRoot.className = 'quick-print-detached-root print-surface'
        detachedRoot.style.position = 'absolute'
        detachedRoot.style.left = '-100000px'
        detachedRoot.style.top = '0'
        detachedRoot.style.width = `${widthOfA4Page}px`
        detachedRoot.style.maxWidth = `${widthOfA4Page}px`
        detachedRoot.style.background = 'white'
        detachedRoot.style.zIndex = '-1'
        const getDrawerPagesHTML = () => {
          const _pages = Array.from(container.querySelectorAll('.prescription-page'))
          const _byNum = new Map()
          _pages.forEach((p) => {
            const n = p.getAttribute('data-page-number') || p.getAttribute('data-pdf-page')
            if (!n) return
            if (!_byNum.has(n)) _byNum.set(n, p)
          })
          const _sorted = Array.from(_byNum.entries())
            .sort((a, b) => (parseInt(a[0], 10) || 0) - (parseInt(b[0], 10) || 0))
            .map(([, p]) => p)
          return {
            html: _sorted.map((p) => p.outerHTML).join(''),
            count: _sorted.length,
          }
        }
        const drawerPayload = clonedPagesHTML
          ? { html: clonedPagesHTML, count: (container.querySelectorAll('.prescription-page') || []).length }
          : getDrawerPagesHTML()
        detachedRoot.innerHTML = drawerPayload.html || ''
        document.body.appendChild(detachedRoot)
        const detachedPages = Array.from(detachedRoot.querySelectorAll('.prescription-page'))
        const detachedFirst = detachedPages[0] || null
        const detachedSecond = detachedPages[1] || null
        const allPagesNow = Array.from(document.querySelectorAll('.prescription-page'))
        const drawerPagesNow = Array.from(container.querySelectorAll('.prescription-page'))
        const detachedSetNow = new Set(detachedPages)
        const drawerSetNow = new Set(drawerPagesNow)
        const outsidePagesNow = allPagesNow.filter(
          (el) => !detachedSetNow.has(el) && !drawerSetNow.has(el)
        )

        const isDetachedReady = () => {
          const _root = document.getElementById(detachedRootId)
          if (!_root) return false
          const _pages = Array.from(_root.querySelectorAll('.prescription-page'))
          if (_pages.length === 0) return false
          return _pages.every((p) => {
            const r = p.getBoundingClientRect()
            const a4 = p.querySelector('[id^="a4-"]')
            return r.width > 100 && r.height > 100 && !!a4
          })
        }
        const waitForDetachedReady = (attempt = 0, maxAttempts = 24) => {
          if (isDetachedReady()) return Promise.resolve(attempt)
          if (attempt >= maxAttempts) return Promise.resolve(attempt)
          return new Promise((resolve) => {
            window.requestAnimationFrame(() => {
              resolve(waitForDetachedReady(attempt + 1, maxAttempts))
            })
          })
        }
        
        // Wait for detached print surface readiness, then trigger print
        waitForDetachedReady().then((readyAttempts) => {
          window.requestAnimationFrame(() => {
              console.log(`[PrescriptionMakingPage] Triggering print dialog with ${pages.length} pages...`)
              // Clean up print CSS and restore styles after print lifecycle completes
              let didCleanup = false
              const cleanup = (reason = 'unknown') => {
                if (didCleanup) return
                didCleanup = true
                console.log('[PrescriptionMakingPage] Cleaning up print CSS and styles...')
                const styleToRemove = document.getElementById(printStyleId)
                if (styleToRemove) {
                  styleToRemove.remove()
                }
                const detachedEl = document.getElementById(detachedRootId)
                if (detachedEl) {
                  detachedEl.remove()
                }
                for (let i = tempStyleChanges.length - 1; i >= 0; i -= 1) {
                  const ch = tempStyleChanges[i]
                  if (!ch?.el?.style) continue
                  if (ch.prevValue) {
                    ch.el.style.setProperty(ch.prop, ch.prevValue, ch.prevPriority || '')
                  } else {
                    ch.el.style.removeProperty(ch.prop)
                  }
                }
                // Restore container styles
                if (container) {
                  container.style.height = originalContainerStyle.height || ''
                  container.style.maxHeight = originalContainerStyle.maxHeight || ''
                  container.style.minHeight = originalContainerStyle.minHeight || ''
                  container.style.overflow = originalContainerStyle.overflow || ''
                  container.style.overflowY = originalContainerStyle.overflowY || ''
                }
              }

              const cleanupOnAfterPrint = () => cleanup('afterprint')
              window.addEventListener('afterprint', cleanupOnAfterPrint, { once: true })
              const cleanupMq = window.matchMedia ? window.matchMedia('print') : null
              if (cleanupMq?.addEventListener) {
                const onCleanupPrintChange = (evt) => {
                  if (!evt?.matches) {
                    cleanup('matchMedia-false')
                    cleanupMq.removeEventListener('change', onCleanupPrintChange)
                  }
                }
                cleanupMq.addEventListener('change', onCleanupPrintChange)
              }

              window.print()
            })
        })
      }
      
      // Start checking after a short delay to allow drawer to start opening
      window.setTimeout(checkAndPrint, 400)
    }, [quickPrintDrawerOpen, clonedPagesHTML, colorMode, printSettings, quickPrintTriggerCount])

    useImperativeHandle(componentRef, () => ({
      savePrescriptionData: savePrescriptionData,
      openPreview: goToPrintPage,
      saveAndPrint: saveAndPrint,
      saveAndPrintDirect: saveAndPrintDirect, // Direct print without drawer
      generateClientSidePDFForPrint: generateClientSidePDFForPrint,
      quickPrint: quickPrint, // Quick print - clones pages and opens drawer
    }))

    if (mentorProfileDataLoading) {
      return <LoadingSpinner />
    } else {
      return (
        <>
          <PrescriptionTabFinalParent
            style={{ width: '100%', paddingTop: '23px' }}
            printType={printType}
          >
            <ActiveStaffMarqueeComponent
              containerStylesOverride={{
                position: 'fixed',
                top: '110px',
                zIndex: 9,
              }}
            />
            <div
              className="hide-on-print"
              style={{
                position: 'relative',
                overflow: 'visible',
                height:
                  prescriptionViewSettings?.prescriptionBuilderViewType ===
                  PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView
                    ? '100%'
                    : 'unset',
                background: '#F5F5F5',
                borderRadius: '8px',
                marginBottom: '24px',
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <TopPatientDetailsHeading
                  prescriptionSaveLoading={prescriptionSaveLoading}
                  saveAndPrint={saveAndPrint}
                  savePrescriptionData={savePrescriptionData}
                  prescriptionViewSettings={prescriptionViewSettings}
                  currentPage={currentPage}
                  emrSectionsToShowInOrder={emrSectionsToShowInOrderForDocOn}
                  nextSection={nextSection}
                  previousSection={previousSection}
                  currentPageHistory={currentPageHistory}
                  inChamber={inChamber}
                  saveAndDownloadPDF={saveAndDownloadPDF}
                  onRxPrint={onRxPrint}
                  onQuickPrint={quickPrint}
                  onEditSections={emrSectionsEditorDialogHandleOpen}
                />
                {/* body */}
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                  className="px-1 py-1"
                >
                  {prescriptionViewSettings?.prescriptionBuilderViewType ===
                    PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView && (
                    <>
                      {renderSectionForDoconLayout(
                        emrSectionsToShowInOrderForDocOn?.[currentPage],
                        emrSectionsToShowInOrderForDocOn?.[currentPage + 1],
                      )}
                    </>
                  )}
                  {prescriptionViewSettings?.prescriptionBuilderViewType !==
                    PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView && (
                    <>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <SectionSecondaryHeadingAndContent>
                          {/* <PMPSectionInputLabel main>Patient Name: </PMPSectionInputLabel> */}
                          {/* {prescriptionData ? (
                            <PMPSectionInputLabel>
                              {prescriptionData?.patientPrefill?.name}
                            </PMPSectionInputLabel>
                          ) : (
                            '...'
                          )} */}
                          {bookedEventInfo?.patientMeetingSeqNumber && prescriptionData && (
                            <>
                              <Box
                                sx={{
                                  mb: 1.5,
                                  px: '14px',
                                  py: '10px',
                                  background: '#ffffff',
                                  borderRadius: '10px',
                                  border: '1px solid rgba(0, 0, 0, 0.07)',
                                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                                }}
                              >
                                {/* Visit header strip — single compact row */}
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    flexWrap: 'wrap',
                                    mb: 1.25,
                                    pb: 1.25,
                                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                                  }}
                                >
                                  <Chip
                                    label={`${getOrdinalSuffix(bookedEventInfo?.patientMeetingSeqNumber)} Visit`}
                                    sx={{
                                      height: 24,
                                      fontSize: '12px',
                                      fontWeight: 700,
                                      background: 'rgba(99, 102, 241, 0.1)',
                                      color: '#6366f1',
                                      border: '1px solid rgba(99, 102, 241, 0.2)',
                                      '& .MuiChip-label': { px: 1.5 },
                                    }}
                                  />
                                  <Typography
                                    onClick={() => {
                                      if (historySectionRef) {
                                        historySectionRef.current?.scrollIntoView({ behavior: 'smooth' })
                                      }
                                    }}
                                    sx={{
                                      cursor: 'pointer',
                                      fontWeight: 500,
                                      color: '#6366f1',
                                      fontSize: '12px',
                                      textDecoration: 'underline',
                                      textUnderlineOffset: '2px',
                                      '&:hover': { color: '#4f46e5' },
                                    }}
                                  >
                                    View Past
                                  </Typography>
                                  <Box sx={{ flex: 1 }} />
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <CalendarToday sx={{ fontSize: 13, color: '#9ca3af' }} />
                                    <Typography sx={{ fontSize: '12px', color: '#6b7280', fontWeight: 500 }}>
                                      {getDateOfPrescription(prescriptionData)}
                                    </Typography>
                                  </Box>
                                  {/* Autofill — sits at the end of the strip */}
                                  {bookedEventInfo?.patientId && (
                                    <AutoFillFromLastPrescriptionComponent
                                      patientId={bookedEventInfo?.patientId}
                                      thisBookedEventId={bookedEventInfo?.id}
                                      clickFunction={(data) => autofillPrescriptionUsingData(data)}
                                    />
                                  )}
                                </Box>
                                {/* Patient Visit Summary Cards */}
                                {screenWidth > 1000 && (
                                  <PatientVisitSummaryHandler
                                    patientVisitSummary={auxiliaryDataFromProps?.patientVisitSummary}
                                    onReferForTherapy={() => {
                                      setSuggestedBookingTherapy(true)
                                      setTimeout(() => {
                                        const therapySection = document.querySelector('[data-section-id="therapy_recommendation"]')
                                        if (therapySection) {
                                          therapySection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                                        }
                                      }, 100)
                                    }}
                                    onReferForAssessment={() => {
                                      setTimeout(() => {
                                        const assessmentSection = document.querySelector('[data-section-id="psych_assessments"]')
                                        if (assessmentSection) {
                                          assessmentSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                                        }
                                      }, 100)
                                    }}
                                  />
                                )}
                              </Box>
                              {/* <PMPSectionInputLabel>
                                {bookedEventInfo?.patientMeetingSeqNumber === 1
                                  ? '(New Patient)'
                                  : `(Existing Patient, Visit: ${bookedEventInfo?.patientMeetingSeqNumber})`}
                              </PMPSectionInputLabel> */}
                            </>
                          )}
                        </SectionSecondaryHeadingAndContent>
                        {/* Patient Information and Fee Header - Only on Mobile */}
                        {prescriptionData?.patientPrefill && screenWidth <= 1000 && (
                          <Box
                            sx={{
                              mt: 1.5,
                              mb: 1,
                              px: '12px',
                              py: '8px',
                              background: '#ffffff',
                              borderRadius: '10px',
                              border: '1px solid rgba(0, 0, 0, 0.07)',
                              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              flexWrap: 'wrap',
                            }}
                          >
                            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#111827' }}>
                              {prescriptionData?.patientPrefill?.name || 'N/A'}
                            </Typography>
                            <Chip
                              label={`${getAgeFromDobWithTime(
                                prescriptionData?.patientPrefill?.vital?.dateOfBirth,
                              )} / ${
                                GENDER_LIST_ONBOARDING?.find(
                                  (item) => item.value === prescriptionData?.patientPrefill?.vital?.gender,
                                )?.label || 'N/A'
                              }`}
                              size="small"
                              sx={{
                                height: 22,
                                fontSize: '11px',
                                fontWeight: 600,
                                background: 'rgba(99, 102, 241, 0.1)',
                                color: '#6366f1',
                                '& .MuiChip-label': { px: 1.25 },
                              }}
                            />
                            {prescriptionViewSettings?.prescriptionBuilderViewType ===
                              PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView &&
                              prescriptionData?.patientPrefill?.patientNumber && (
                                <Chip
                                  icon={<BadgeIcon sx={{ fontSize: 12 }} />}
                                  label={`ID: ${prescriptionData?.patientPrefill?.patientNumber}`}
                                  size="small"
                                  sx={{
                                    height: 22,
                                    fontSize: '11px',
                                    fontWeight: 600,
                                    background: 'rgba(16, 185, 129, 0.1)',
                                    color: '#10b981',
                                    '& .MuiChip-label': { px: 1.25 },
                                  }}
                                />
                              )}
                            <Box sx={{ flex: 1 }} />
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                              <CalendarToday sx={{ fontSize: 13, color: '#9ca3af' }} />
                              <Typography sx={{ fontSize: '12px', color: '#6b7280', fontWeight: 500 }}>
                                {getDateOfPrescription(prescriptionData)}
                              </Typography>
                            </Box>
                            {bookedEventInfo?.feePaid && (
                              <Chip
                                label={getPriceStringWithCurrency(bookedEventInfo?.feePaid, bookedEventInfo?.currency)}
                                size="small"
                                sx={{
                                  height: 22,
                                  fontSize: '11px',
                                  fontWeight: 700,
                                  background: 'rgba(16, 185, 129, 0.1)',
                                  color: '#059669',
                                  border: '1px solid rgba(16, 185, 129, 0.2)',
                                  '& .MuiChip-label': { px: 1.25 },
                                }}
                              />
                            )}
                          </Box>
                        )}
                        {/* <SectionSecondaryHeadingAndContent>
                          <PMPSectionInputLabel main>Age/Gender: </PMPSectionInputLabel>
                          <PMPSectionInputLabel>
                            {getAgeFromDobWithTime(
                              prescriptionData?.patientPrefill?.vital?.dateOfBirth,
                            )}
                            {
                              GENDER_LIST_ONBOARDING?.find(
                                (item) =>
                                  item.value === prescriptionData?.patientPrefill?.vital?.gender,
                              )?.label
                            }
                          </PMPSectionInputLabel>
                        </SectionSecondaryHeadingAndContent> */}{' '}
                        {/* <SectionSecondaryHeadingAndContent style={{ gap: 0 }}>
                          {' '}
                          <PMPSectionInputLabel style={{ fontWeight: 400 }} main>
                            Prescription Date: //{' '}
                          </PMPSectionInputLabel>{' '}
                          <PMPSectionInputLabel style={{ fontWeight: 400 }}>
                            {getDateOfPrescription(prescriptionData)}{' '}
                          </PMPSectionInputLabel>{' '}
                        </SectionSecondaryHeadingAndContent> */}
                      </div>
                      {screenWidth <= 1000 && (
                        <PatientVisitSummaryHandler
                          patientVisitSummary={auxiliaryDataFromProps?.patientVisitSummary}
                          onReferForTherapy={() => {
                            setSuggestedBookingTherapy(true)
                            setTimeout(() => {
                              const therapySection = document.querySelector('[data-section-id="therapy_recommendation"]')
                              if (therapySection) {
                                therapySection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                              }
                            }, 100)
                          }}
                          onReferForAssessment={() => {
                            setTimeout(() => {
                              const assessmentSection = document.querySelector('[data-section-id="psych_assessments"]')
                              if (assessmentSection) {
                                assessmentSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                              }
                            }, 100)
                          }}
                        />
                      )}
                      <div
                        className="d-flex flex-column"
                        style={{ marginTop: '48px', gap: '32px' }}
                      >
                        {emrSectionsToShowInOrderWithScreening
                          ?.filter((section) => section?.enabled)
                          ?.map((emrSections) => {
                            return (
                              <React.Fragment key={emrSections?.id || `section-${emrSections?.defCode}`}>
                                {renderSectionForHP(emrSections?.id)}
                              </React.Fragment>
                            )
                          })}
                      </div>
                    </>
                  )}
                </div>
                {/* footer */}
                {/*
                prescriptionViewSettings?.prescriptionBuilderViewType ===
                PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView && (
                <PrescriptionFooterComponent
                  goToPrintPage={goToPrintPage}
                  onPrescriptionPreviewPage={onPrescriptionPreviewPage}
                />
              )
              */}
              </div>
            </div>

            <div>
              {renderPrescriptionView({
                showInUI:
                  prescriptionViewSettings?.prescriptionBuilderViewType !==
                  PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView,
              })}
              <div
                className={!isPrintingPastHistoryReports ? 'hide-on-print' : ''}
                style={{ margin: '0 auto', width: '95%', position: 'relative', zIndex: 1 }}
              >
                <hr style={{ marginTop: '160px' }} className="hide-on-print-only" />

                <Box
                  ref={historySectionRef}
                  className="hide-on-print-only"
                  sx={{
                    marginTop: '160px',
                    marginBottom: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                  }}
                >
                  <PMPSectionHeading style={{ margin: 0, flex: 1 }}>
                    Patient History
                  </PMPSectionHeading>
                  <Tooltip title="Print All Reports">
                    <IconButton
                      onClick={() => {
                        printWithPaged()
                      }}
                      disabled={isPagedPrinting}
                      size="small"
                      sx={{
                        color: 'rgba(67, 56, 202, 0.7)',
                        '&:hover': {
                          backgroundColor: 'rgba(67, 56, 202, 0.08)',
                          color: 'rgba(67, 56, 202, 0.9)',
                        },
                        '&:disabled': {
                          color: 'rgba(67, 56, 202, 0.4)',
                        },
                      }}
                    >
                      {isPagedPrinting ? (
                        <CircularProgress size={20} />
                      ) : (
                        <Print sx={{ fontSize: 20 }} />
                      )}
                    </IconButton>
                  </Tooltip>
                </Box>
                {propBookedEventInfo?.patientId && (
                  <LSPastVisitReportsComponent
                    patientId={propBookedEventInfo?.patientId}
                    referenceBookedEventId={eventId}
                    screeningSections={screeningSections}
                    allVitalsOfThisPatient={allVitalsOfThisPatient}
                    setIsPrintingPastHistoryReports={setIsPrintingPastHistoryReports}
                    mentorPrivateNotes={auxiliaryDataFromProps?.mentorPrivateNotes}
                    role="doctor"
                    prescriptionViewSettings={prescriptionViewSettings}
                    clinicId={propBookedEventInfo?.clinicId}
                  />
                )}
              </div>
            </div>
          </PrescriptionTabFinalParent>

          {/* EMR Sections Editor Dialog */}
          <EmrSectionsEditorDialog
            open={emrSectionsEditorDialogOpen}
            handleClose={emrSectionsEditorDialogHandleClose}
            refreshEmrSections={refreshEmrSections}
            mentorProfileData={mentorProfileData}
          />

          {/* Guard Dialog for Pre-Save Validation */}
          {guardDialog.open && guardDialog.guardDef && (
            <EmrActionDialog
              open={guardDialog.open}
              onClose={() => {
                handleGuardDialogResponse(false)
                setGuardDialog({ open: false, guardDef: null })
              }}
              dialogDef={guardDialog.guardDef.dialog}
              onSubmit={(formData) => {
                handleGuardDialogResponse(true, formData)
                setGuardDialog({ open: false, guardDef: null })
              }}
            />
          )}

          {/* PDF Viewer Drawer */}
          <Drawer
            anchor="bottom"
            open={pdfDrawerOpen}
            keepMounted={false}
            onClose={() => {
              // Don't close drawer if PDF is generating (user should see progress)
              if (pdfGenerating) {
                console.log('[Drawer] Prevented close: PDF is still generating')
                return
              }
              // Don't close drawer if auto-print is active (user should see the PDF)
              if (shouldAutoPrint && pdfUrl) {
                console.log('[Drawer] Prevented close: Auto-print is active')
                return
              }
              // Allow closing only if PDF generation is complete and auto-print is not active
              setPdfDrawerOpen(false)
              setShouldAutoPrint(false)
              setIsDownloadMode(false)
              // Clean up PDF URL when drawer closes
              if (pdfUrl) {
                try {
                  URL.revokeObjectURL(pdfUrl)
                } catch (revokeError) {
                  console.warn('Error revoking PDF URL on drawer close:', revokeError)
                }
                setPdfUrl(null)
              }
              // Clean up PDF blob
              setPdfBlob(null)
            }}
            PaperProps={{
              sx: {
                width: '100%',
                maxWidth: '100%',
                height: '90vh',
                maxHeight: '90vh',
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1300, // Ensure drawer is above other content
              },
            }}
            ModalProps={{
              disableScrollLock: true,
            }}
            BackdropProps={{
              onClick: (event) => {
                // Prevent backdrop click from closing drawer during auto-print
                if (shouldAutoPrint && pdfUrl) {
                  event.preventDefault()
                  event.stopPropagation()
                }
              },
              sx: {
                // Make backdrop non-clickable during auto-print (visual feedback)
                pointerEvents: shouldAutoPrint && pdfUrl ? 'none' : 'auto',
              },
            }}
            // Disable escape key closing during auto-print
            hideBackdrop={false}
            disableEscapeKeyDown={!!(shouldAutoPrint && pdfUrl)}
          >
            {/* Drawer Header */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                flexShrink: 0,
                gap: 2,
              }}
            >
              <Typography variant="h6" fontWeight={600} sx={{ flex: 1 }}>
                {isDownloadMode ? 'Prescription PDF - Download' : 'Prescription PDF Preview'}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexShrink: 0 }}>
                {isDownloadMode ? (
                  <>
                    <Button
                      variant="outlined"
                      color="emrSecondary"
                      startIcon={<WhatsApp />}
                      onClick={handleSendPDFToPatient}
                      disabled={pdfGenerating || !bookedEventInfo?.id}
                      sx={{
                        borderColor: 'rgba(67, 56, 202, 0.5)',
                        color: '#4338ca',
                        minWidth: 'auto',
                        px: 2,
                        '&:hover': {
                          borderColor: '#4338ca',
                          backgroundColor: 'rgba(67, 56, 202, 0.08)',
                        },
                        '&.Mui-disabled': {
                          borderColor: 'rgba(67, 56, 202, 0.3)',
                          color: 'rgba(67, 56, 202, 0.3)',
                        },
                      }}
                    >
                      Send to Patient
                    </Button>
                    <Button
                      variant="outlined"
                      color="emrSecondary"
                      startIcon={<Print />}
                      onClick={() => {
                        // Try to print directly from the iframe in the drawer
                        if (pdfIframeRef.current && pdfIframeRef.current.contentWindow) {
                          try {
                            pdfIframeRef.current.contentWindow.focus()
                            pdfIframeRef.current.contentWindow.print()
                          } catch (e) {
                            // If direct iframe print fails, fall back to opening in new window
                            console.warn('Direct iframe print failed, using fallback:', e)
                            if (pdfUrl) {
                              const printWindow = window.open(pdfUrl, '_blank')
                              if (printWindow) {
                                printWindow.onload = () => {
                                  setTimeout(() => {
                                    printWindow.print()
                                  }, 500)
                                }
                              }
                            }
                          }
                        } else if (pdfUrl) {
                          // Fallback if iframe is not ready
                          const printWindow = window.open(pdfUrl, '_blank')
                          if (printWindow) {
                            printWindow.onload = () => {
                              setTimeout(() => {
                                printWindow.print()
                              }, 500)
                            }
                          }
                        }
                      }}
                      disabled={!pdfUrl || pdfGenerating}
                      sx={{
                        borderColor: 'rgba(67, 56, 202, 0.5)',
                        color: '#4338ca',
                        minWidth: 'auto',
                        px: 2,
                        '&:hover': {
                          borderColor: '#4338ca',
                          backgroundColor: 'rgba(67, 56, 202, 0.08)',
                        },
                        '&.Mui-disabled': {
                          borderColor: 'rgba(67, 56, 202, 0.3)',
                          color: 'rgba(67, 56, 202, 0.3)',
                        },
                      }}
                    >
                      Print
                    </Button>
                    <Button
                      variant="contained"
                      color="emrSecondary"
                      startIcon={<Download />}
                      onClick={handleDownloadPDFFromDrawer}
                      disabled={!pdfBlob || pdfGenerating}
                      sx={{
                        minWidth: 'auto',
                        px: 2,
                        '&.Mui-disabled': {
                          backgroundColor: 'rgba(67, 56, 202, 0.3)',
                          color: 'rgba(255, 255, 255, 0.5)',
                        },
                      }}
                    >
                      Download PDF
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="contained"
                    color="emrSecondary"
                    startIcon={<Print />}
                    onClick={() => {
                      // Try to print directly from the iframe in the drawer
                      if (pdfIframeRef.current && pdfIframeRef.current.contentWindow) {
                        try {
                          pdfIframeRef.current.contentWindow.focus()
                          pdfIframeRef.current.contentWindow.print()
                        } catch (e) {
                          // If direct iframe print fails, fall back to opening in new window
                          console.warn('Direct iframe print failed, using fallback:', e)
                          if (pdfUrl) {
                            const printWindow = window.open(pdfUrl, '_blank')
                            if (printWindow) {
                              printWindow.onload = () => {
                                setTimeout(() => {
                                  printWindow.print()
                                }, 500)
                              }
                            }
                          }
                        }
                      } else if (pdfUrl) {
                        // Fallback if iframe is not ready
                        const printWindow = window.open(pdfUrl, '_blank')
                        if (printWindow) {
                          printWindow.onload = () => {
                            setTimeout(() => {
                              printWindow.print()
                            }, 500)
                          }
                        }
                      }
                    }}
                    disabled={!pdfUrl || pdfGenerating}
                    sx={{
                      minWidth: 'auto',
                      px: 2,
                      '&.Mui-disabled': {
                        backgroundColor: 'rgba(67, 56, 202, 0.3)',
                        color: 'rgba(255, 255, 255, 0.5)',
                      },
                    }}
                  >
                    Print
                  </Button>
                )}
                <IconButton
                  onClick={() => {
                    setPdfDrawerOpen(false)
                    setIsDownloadMode(false)
                    if (pdfUrl) {
                      URL.revokeObjectURL(pdfUrl)
                      setPdfUrl(null)
                    }
                    setPdfBlob(null)
                  }}
                  sx={{
                    color: 'text.primary',
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                    '&:active': {
                      transform: 'none', // Prevent movement on click
                    },
                  }}
                >
                  <Close />
                </IconButton>
              </Box>
            </Box>

            {/* PDF Viewer */}
            <Box
              sx={{
                flex: 1,
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                p: 2,
                backgroundColor: '#f5f5f5',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                '& iframe': {
                  maxWidth: '100%',
                  objectFit: 'contain',
                },
              }}
            >
              {pdfGenerating ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 3,
                    minHeight: '500px',
                    width: '100%',
                    padding: 4,
                  }}
                >
                  <CircularProgress 
                    size={80} 
                    thickness={4}
                    sx={{
                      color: 'primary.main',
                    }}
                  />
                  <Typography 
                    variant="h6" 
                    color="text.primary" 
                    sx={{ 
                      mt: 2, 
                      textAlign: 'center',
                      fontWeight: 600,
                    }}
                  >
                    {pdfProgressMessage || 'Preparing PDF for printing...'}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    color="text.secondary" 
                    sx={{ 
                      textAlign: 'center',
                      maxWidth: '400px',
                    }}
                  >
                    Please wait while we generate your prescription PDF. This may take a few moments.
                  </Typography>
                </Box>
              ) : pdfUrl ? (
                <>
                <iframe
                  ref={pdfIframeRef}
                  src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0&zoom=page-fit`}
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    border: 'none',
                    minHeight: '600px',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                  }}
                  title="Prescription PDF Preview"
                    onLoad={() => {
                      // If auto-print is enabled and PDF is loaded, trigger print immediately
                      if (shouldAutoPrint && !pdfGenerating && pdfIframeRef.current?.contentWindow) {
                        // Trigger print immediately when iframe loads (no delay)
                        try {
                          // Inject color mode CSS into iframe before printing
                          try {
                            const iframeWindow = pdfIframeRef.current.contentWindow
                            if (iframeWindow && iframeWindow.document) {
                              injectColorModeCSS(iframeWindow, colorMode === 'bw')
                            }
                          } catch (cssError) {
                            console.warn('[PDF Drawer onLoad] Could not inject color mode CSS:', cssError)
                          }
                          
                          pdfIframeRef.current.contentWindow.focus()
                          pdfIframeRef.current.contentWindow.print()
                          // Update loading toast to success when print dialog opens
                          const toastId = loadingToastIdRef.current
                          if (toastId) {
                            toast.update(toastId, {
                              render: 'Opening print dialog...',
                              type: 'success',
                              isLoading: false,
                              autoClose: 2000,
                            })
                            loadingToastIdRef.current = null
                          }
                        } catch (printErr) {
                          console.error('[PDF Drawer] Error triggering print from onLoad:', printErr)
                          // Fallback: try again after short delay
                          setTimeout(() => {
                            try {
                              // Inject color mode CSS before fallback print
                              try {
                                const iframeWindow = pdfIframeRef.current.contentWindow
                                if (iframeWindow && iframeWindow.document) {
                                  injectColorModeCSS(iframeWindow, colorMode === 'bw')
                                }
                              } catch (cssError) {
                                console.warn('[PDF Drawer onLoad Fallback] Could not inject color mode CSS:', cssError)
                              }
                              
                              pdfIframeRef.current.contentWindow.print()
                              // Dismiss toast on fallback print too
                              if (loadingToastIdRef.current) {
                            const toastId = loadingToastIdRef.current
                            if (toastId) {
                              toast.update(toastId, {
                                render: 'Opening print dialog...',
                                type: 'success',
                                isLoading: false,
                                autoClose: 2000,
                              })
                              loadingToastIdRef.current = null
                            }
                              }
                            } catch (e) {
                              console.error('[PDF Drawer] Fallback print also failed:', e)
                              // Dismiss toast even on error
                              if (loadingToastIdRef.current) {
                            const toastId = loadingToastIdRef.current
                            if (toastId) {
                              toast.update(toastId, {
                                render: 'Opening print dialog...',
                                type: 'success',
                                isLoading: false,
                                autoClose: 2000,
                              })
                              loadingToastIdRef.current = null
                            }
                              }
                            }
                          }, 200)
                        }
                      }
                    }}
                    onError={(e) => {
                      console.error('[PDF Drawer] Iframe load error:', e, {
                        pdfUrl,
                        shouldAutoPrint
                      })
                    }}
                  />
                </>
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2,
                    minHeight: '400px',
                  }}
                >
                  <Typography variant="body1" color="text.secondary">
                    No PDF available
                  </Typography>
                </Box>
              )}
            </Box>
          </Drawer>

          {/* Mobile Speed Dial for Quick Access */}
          {isMobile && (
            <SpeedDial
              ariaLabel="Mobile prescription navigation"
              sx={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                zIndex: 1000,
                '& .MuiFab-primary': {
                  background: 'linear-gradient(135deg, #4338ca 0%, #6366f1 100%)',
                  boxShadow: '0 4px 20px rgba(67, 56, 202, 0.4)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #3730a3 0%, #4f46e5 100%)',
                  },
                },
              }}
              icon={<SpeedDialIcon icon={<MenuIcon />} openIcon={<Close />} />}
            >
              <SpeedDialAction
                icon={<History />}
                tooltipTitle="History"
                tooltipOpen
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  // Use requestAnimationFrame to ensure state update happens after SpeedDial closes
                  requestAnimationFrame(() => {
                    setMobileHistoryDrawerOpen(true)
                  })
                }}
                sx={{
                  '& .MuiSpeedDialAction-fab': {
                    background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
                    color: '#fff',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #d97706 0%, #f59e0b 100%)',
                    },
                  },
                }}
              />
              <SpeedDialAction
                icon={<Medication />}
                tooltipTitle="Rx"
                tooltipOpen
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  // Use requestAnimationFrame to ensure state update happens after SpeedDial closes
                  requestAnimationFrame(() => {
                    setMobileRxDrawerOpen(true)
                  })
                }}
                sx={{
                  '& .MuiSpeedDialAction-fab': {
                    background: 'linear-gradient(135deg, #22c55e 0%, #4ade80 100%)',
                    color: '#fff',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)',
                    },
                  },
                }}
              />
              <SpeedDialAction
                icon={<MonitorHeart />}
                tooltipTitle="Vitals"
                tooltipOpen
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  // Use requestAnimationFrame to ensure state update happens after SpeedDial closes
                  requestAnimationFrame(() => {
                    setMobileVitalsDrawerOpen(true)
                  })
                }}
                sx={{
                  '& .MuiSpeedDialAction-fab': {
                    background: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
                    color: '#fff',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                    },
                  },
                }}
              />
            </SpeedDial>
          )}

          {/* Mobile History Drawer */}
          <Drawer
            anchor="bottom"
            open={mobileHistoryDrawerOpen}
            onClose={() => setMobileHistoryDrawerOpen(false)}
            PaperProps={{
              sx: {
                height: '90vh',
                maxHeight: '90vh',
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
                overflow: 'hidden',
                zIndex: 1300, // Higher than MUI default (1200) and header (1001)
              },
            }}
            ModalProps={{
              keepMounted: true,
              disableAutoFocus: true,
            }}
          >
            {/* History Drawer Header */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
                borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                flexShrink: 0,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <History sx={{ color: '#fff', fontSize: 28 }} />
                <Typography variant="h6" fontWeight={700} color="#fff">
                  Patient History
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Tooltip title="Print All Reports">
                  <IconButton
                    onClick={() => {
                      printWithPaged()
                    }}
                    disabled={isPagedPrinting}
                    sx={{
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                      },
                      '&:disabled': {
                        color: 'rgba(255, 255, 255, 0.5)',
                      },
                    }}
                  >
                    {isPagedPrinting ? (
                      <CircularProgress size={24} sx={{ color: '#fff' }} />
                    ) : (
                      <Print sx={{ fontSize: 24 }} />
                    )}
                  </IconButton>
                </Tooltip>
                <IconButton
                  onClick={() => setMobileHistoryDrawerOpen(false)}
                  sx={{
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    },
                  }}
                >
                  <Close />
                </IconButton>
              </Box>
            </Box>
            {/* History Drawer Content */}
            <Box
              sx={{
                flex: 1,
                overflow: 'auto',
                p: 2,
                backgroundColor: '#f9fafb',
              }}
            >
              {propBookedEventInfo?.patientId ? (
                <LSPastVisitReportsComponent
                  patientId={propBookedEventInfo?.patientId}
                  referenceBookedEventId={eventId}
                  screeningSections={screeningSections}
                  allVitalsOfThisPatient={allVitalsOfThisPatient}
                  setIsPrintingPastHistoryReports={setIsPrintingPastHistoryReports}
                  mentorPrivateNotes={auxiliaryDataFromProps?.mentorPrivateNotes}
                  role="doctor"
                  prescriptionViewSettings={prescriptionViewSettings}
                  clinicId={propBookedEventInfo?.clinicId}
                />
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    gap: 2,
                  }}
                >
                  <History sx={{ fontSize: 64, color: '#d1d5db' }} />
                  <Typography color="text.secondary">No patient history available</Typography>
                </Box>
              )}
            </Box>
          </Drawer>

          {/* Mobile Rx (Prescription) Drawer */}
          <Drawer
            anchor="bottom"
            open={mobileRxDrawerOpen}
            onClose={() => setMobileRxDrawerOpen(false)}
            PaperProps={{
              sx: {
                height: '90vh',
                maxHeight: '90vh',
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
                overflow: 'hidden',
                zIndex: 1300, // Higher than MUI default (1200) and header (1001)
              },
            }}
            ModalProps={{
              keepMounted: true,
              disableAutoFocus: true,
            }}
          >
            {/* Rx Drawer Header */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                background: 'linear-gradient(135deg, #22c55e 0%, #4ade80 100%)',
                borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                flexShrink: 0,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Medication sx={{ color: '#fff', fontSize: 28 }} />
                <Typography variant="h6" fontWeight={700} color="#fff">
                  Prescription (Rx)
                </Typography>
              </Box>
              <IconButton
                onClick={() => setMobileRxDrawerOpen(false)}
                sx={{
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  },
                }}
              >
                <Close />
              </IconButton>
            </Box>
            {/* Rx Drawer Content */}
            <Box
              sx={{
                flex: 1,
                overflow: 'auto',
                p: 2,
                backgroundColor: '#f9fafb',
              }}
            >
              <DrugAdviceInput
                prescriptionViewSettings={prescriptionViewSettings}
                drugsAdvice={drugsAdvice}
                setDrugsAdvice={setDrugsAdvice}
                handleAddDrugAdviceItem={handleAddDrugAdviceItem}
                handleDeleteDrugAdviceItem={handleDeleteDrugAdviceItem}
                clinicId={clinicId}
                clinicBrandId={clinicBrandId}
                recommendedHealthEntityForDoctor={recommendedHealthEntityForDoctor}
                mentorProfileData={mentorProfileData}
                drugAdviceTypes={drugAdviceTypes}
                drugAdviceWhatTimeOptions={drugAdviceWhatTimeOptions}
                drugAdviceFrequencies={drugAdviceFrequencies}
                drugAdviceDurations={drugAdviceDurations}
                drugAdviceNotes={drugAdviceNotes}
                drugAdviceDosages={drugAdviceDosages}
                contextMenuSide="left"
                drugAdviceSubSections={drugAdviceSubSections}
              />
            </Box>
          </Drawer>

          {/* Mobile Vitals History Drawer */}
          <Drawer
            anchor="bottom"
            open={mobileVitalsDrawerOpen}
            onClose={() => setMobileVitalsDrawerOpen(false)}
            PaperProps={{
              sx: {
                height: '90vh',
                maxHeight: '90vh',
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
                overflow: 'hidden',
                zIndex: 1300, // Higher than MUI default (1200) and header (1001)
              },
            }}
            ModalProps={{
              keepMounted: true,
              disableAutoFocus: true,
            }}
          >
            {/* Vitals Drawer Header */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                background: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
                borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                flexShrink: 0,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <MonitorHeart sx={{ color: '#fff', fontSize: 28 }} />
                <Typography variant="h6" fontWeight={700} color="#fff">
                  Vitals History
                </Typography>
              </Box>
              <IconButton
                onClick={() => setMobileVitalsDrawerOpen(false)}
                sx={{
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  },
                }}
              >
                <Close />
              </IconButton>
            </Box>
            {/* Vitals Drawer Content */}
            <Box
              sx={{
                flex: 1,
                overflow: 'auto',
                p: 2,
                backgroundColor: '#f9fafb',
              }}
            >
              {allVitalsOfThisPatient && allVitalsOfThisPatient.length > 0 ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {/* Current Vitals Entry */}
                  <Card
                    sx={{
                      borderRadius: '16px',
                      border: '2px solid #ef4444',
                      boxShadow: '0 4px 20px rgba(239, 68, 68, 0.15)',
                    }}
                  >
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight={700} color="#ef4444" gutterBottom>
                        Current Visit Vitals
                      </Typography>
                      <VitalsComponentInlineEntryComponent
                        screeningSections={screeningSections}
                        clinicId={clinicId}
                        clinicBrandId={clinicBrandId}
                        patientId={patientId}
                        withCreateButton={true}
                        bookedEventId={bookedEventInfo?.id}
                        existingVitalData={allVitalsOfThisPatient?.find(
                          (item) => item?.bookedEventId === bookedEventInfo?.id,
                        )}
                        locallyChangeExistingVitalData={(newVitalForThisBooking) => {
                          setAllVitalsOfThisPatient((prev) => {
                            const vitalCopy = prev ? [...prev] : []
                            const foundIndex = vitalCopy.findIndex(
                              (item) => item?.bookedEventId === bookedEventInfo?.id,
                            )
                            if (foundIndex !== -1) {
                              vitalCopy[foundIndex] = newVitalForThisBooking
                            } else {
                              vitalCopy.push(newVitalForThisBooking)
                            }
                            return vitalCopy
                          })
                        }}
                      />
                    </CardContent>
                  </Card>

                  {/* Past Vitals */}
                  <Typography variant="subtitle1" fontWeight={600} color="text.secondary" sx={{ mt: 1 }}>
                    Past Vitals History
                  </Typography>
                  {allVitalsOfThisPatient
                    ?.filter((vital) => vital?.bookedEventId !== bookedEventInfo?.id)
                    ?.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt))
                    ?.map((vital, index) => (
                      <Card
                        key={vital?.id || index}
                        sx={{
                          borderRadius: '12px',
                          border: '1px solid rgba(0, 0, 0, 0.08)',
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                        }}
                      >
                        <CardContent sx={{ py: 1.5 }}>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: 'block', mb: 1 }}
                          >
                            {dayjs(vital?.createdAt).format('DD MMM YYYY, hh:mm A')}
                          </Typography>
                          <Box
                            sx={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(2, 1fr)',
                              gap: 1,
                            }}
                          >
                            {vital?.bp && (
                              <Box
                                sx={{
                                  p: 1,
                                  borderRadius: '8px',
                                  backgroundColor: 'rgba(239, 68, 68, 0.08)',
                                }}
                              >
                                <Typography variant="caption" color="text.secondary">
                                  BP
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                  {vital.bp}
                                </Typography>
                              </Box>
                            )}
                            {vital?.pulse && (
                              <Box
                                sx={{
                                  p: 1,
                                  borderRadius: '8px',
                                  backgroundColor: 'rgba(34, 197, 94, 0.08)',
                                }}
                              >
                                <Typography variant="caption" color="text.secondary">
                                  Pulse
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                  {vital.pulse} bpm
                                </Typography>
                              </Box>
                            )}
                            {vital?.temperature && (
                              <Box
                                sx={{
                                  p: 1,
                                  borderRadius: '8px',
                                  backgroundColor: 'rgba(245, 158, 11, 0.08)',
                                }}
                              >
                                <Typography variant="caption" color="text.secondary">
                                  Temp
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                  {vital.temperature}°F
                                </Typography>
                              </Box>
                            )}
                            {vital?.weight && (
                              <Box
                                sx={{
                                  p: 1,
                                  borderRadius: '8px',
                                  backgroundColor: 'rgba(99, 102, 241, 0.08)',
                                }}
                              >
                                <Typography variant="caption" color="text.secondary">
                                  Weight
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                  {vital.weight} kg
                                </Typography>
                              </Box>
                            )}
                            {vital?.height && (
                              <Box
                                sx={{
                                  p: 1,
                                  borderRadius: '8px',
                                  backgroundColor: 'rgba(139, 92, 246, 0.08)',
                                }}
                              >
                                <Typography variant="caption" color="text.secondary">
                                  Height
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                  {vital.height} cm
                                </Typography>
                              </Box>
                            )}
                            {vital?.spo2 && (
                              <Box
                                sx={{
                                  p: 1,
                                  borderRadius: '8px',
                                  backgroundColor: 'rgba(59, 130, 246, 0.08)',
                                }}
                              >
                                <Typography variant="caption" color="text.secondary">
                                  SpO2
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                  {vital.spo2}%
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    ))}
                </Box>
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    gap: 2,
                  }}
                >
                  <MonitorHeart sx={{ fontSize: 64, color: '#d1d5db' }} />
                  <Typography color="text.secondary">No vitals history available</Typography>
                  <Typography variant="caption" color="text.secondary" textAlign="center">
                    Vitals will appear here once recorded for this patient
                  </Typography>
                </Box>
              )}
            </Box>
          </Drawer>

          {/* Paper Rx Template Preview Drawer */}
          <Drawer
            anchor="right"
            open={templateDrawerOpen}
            onClose={() => setTemplateDrawerOpen(false)}
            PaperProps={{
              sx: {
                width: { xs: '100%', sm: '90%', md: '85%' },
                maxWidth: '1400px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              {/* Header */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                p: 2,
                borderBottom: '1px solid',
                borderColor: 'divider',
                flexShrink: 0,
                backgroundColor: 'rgba(67, 56, 202, 0.04)',
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <MenuBook sx={{ color: '#4338ca', fontSize: 28 }} />
                  <Typography variant="h6" fontWeight={600} color="#4338ca">
                    Paper Rx Template Preview
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Button
                    variant="contained"
                    startIcon={<Print />}
                    onClick={() => {
                      window.print()
                    }}
                    disabled={templateLoading || loadingTemplatePrescriptionData || !paperPrescriptionTemplate}
                    sx={{
                      backgroundColor: '#4338ca',
                      '&:hover': {
                        backgroundColor: '#3730a3',
                      },
                    }}
                  >
                    Print
                  </Button>
                  <IconButton onClick={() => setTemplateDrawerOpen(false)}>
                    <Close />
                  </IconButton>
                </Box>
              </Box>
              
              {/* Content - template preview component */}
              <Box 
                sx={{
                  flex: 1,
                  overflow: 'auto',
                  position: 'relative',
                  p: 2,
                  backgroundColor: '#f5f5f5',
                }}
              >
                {templateLoading || loadingTemplatePrescriptionData ? (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) : paperPrescriptionTemplate && currentTemplateWithDummyData ? (
                  <Box
                    sx={{
                      minWidth: '750px',
                      margin: '0px auto',
                      backgroundColor: 'white',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    }}
                  >
                    <ViewOnlyPrescriptionV2
                      prescriptionData={currentTemplateWithDummyData}
                      hidePrintMarginsControl
                      prescriptionViewSettings={prescriptionViewSettings}
                      showTheA4Page
                      doctorEmrSections={currentEmrSections}
                      useEmptyBox={false}
                      useBestFit={false}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                    }}
                  >
                    <Typography color="text.secondary">
                      No prescription template found for this clinic location.
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </Drawer>

          {/* Quick Print Drawer - opens right to left */}
          <Drawer
            anchor={isMobile ? 'bottom' : 'right'}
            open={quickPrintDrawerOpen}
            onClose={() => setQuickPrintDrawerOpen(false)}
            className="quick-print-drawer-root"
            PaperProps={{
              className: 'quick-print-drawer-paper print-surface',
              sx: {
                width: isMobile ? '100%' : { xs: '100%', sm: '90%', md: '80%' },
                maxWidth: isMobile ? '100%' : '1200px',
                height: isMobile ? '90vh' : '100%',
                maxHeight: isMobile ? '90vh' : '100%',
                borderTopLeftRadius: isMobile ? '20px' : 0,
                borderTopRightRadius: isMobile ? '20px' : 0,
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              {/* Header */}
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                p: 2,
                borderBottom: '1px solid',
                borderColor: 'divider',
                flexShrink: 0,
              }}>
                <Typography variant="h6">Print Preview</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Button
                    variant="contained"
                    color="emrSecondary"
                    startIcon={<Print />}
                    onClick={() => setQuickPrintTriggerCount((c) => c + 1)}
                  >
                    Print
                  </Button>
                  <IconButton onClick={() => setQuickPrintDrawerOpen(false)}>
                    <Close />
                  </IconButton>
                </Box>
              </Box>
              
              {/* Content - cloned pages */}
              <Box 
                ref={quickPrintContainerRef}
                className="quick-print-container"
                sx={{ 
                  flex: 1,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  p: 2,
                  backgroundColor: '#f5f5f5',
                  '& .hide-on-print-only': {
                    display: 'none !important',
                  },
                  '& .prescription-page': {
                    backgroundColor: 'white',
                    marginBottom: 2,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  },
                  // Ensure blank header space is visible in drawer preview - rectangle approach
                  '& .blank-header-space': {
                    display: 'block !important',
                    visibility: 'visible !important',
                    height: '120px !important',
                    minHeight: '120px !important',
                    maxHeight: '120px !important',
                    width: '100% !important',
                    flexShrink: 0,
                    flexGrow: 0,
                    flex: '0 0 120px !important',
                    backgroundColor: 'transparent !important',
                    border: '1px solid transparent !important',
                    margin: 0,
                    padding: 0,
                    overflow: 'hidden',
                    position: 'relative',
                  },
                  '& .blank-header-space > span': {
                    display: 'inline-block !important',
                    height: '120px !important',
                    width: '1px !important',
                    opacity: 0,
                    visibility: 'hidden',
                    position: 'absolute',
                    fontSize: '1px',
                    lineHeight: '120px',
                  },
                  '& [class*="PmpHeaderContainer"] > .blank-header-space': {
                    flex: '0 0 120px !important',
                    height: '120px !important',
                    minHeight: '120px !important',
                    maxHeight: '120px !important',
                    width: '100% !important',
                  },
                  // Ensure blank footer space is visible and footer sticks to bottom in drawer preview
                  '& .blank-footer-space': {
                    display: 'block !important',
                    visibility: 'visible !important',
                    height: '120px !important',
                    minHeight: '120px !important',
                    maxHeight: '120px !important',
                    width: '100% !important',
                    flexShrink: 0,
                    flexGrow: 0,
                    flex: '0 0 120px !important',
                    backgroundColor: 'transparent !important',
                    border: '1px solid transparent !important',
                    margin: 0,
                    padding: 0,
                    overflow: 'hidden',
                    position: 'relative',
                  },
                  '& .blank-footer-space > span': {
                    display: 'inline-block !important',
                    height: '120px !important',
                    width: '1px !important',
                    opacity: 0,
                    visibility: 'hidden',
                    position: 'absolute',
                    fontSize: '1px',
                    lineHeight: '120px',
                  },
                  '& [data-print-footer="true"]': {
                    display: 'flex !important',
                    flexDirection: 'column !important',
                    flexShrink: 0,
                    marginTop: 'auto !important',
                  },
                  '& [data-print-spacer="true"], & .footer-spacer-rectangle': {
                    flex: '1 1 auto !important',
                    minHeight: 0,
                    display: 'block !important',
                    width: '100% !important',
                    backgroundColor: 'transparent !important',
                    border: 'none !important',
                    margin: 0,
                    padding: 0,
                    boxSizing: 'border-box',
                    visibility: 'visible !important',
                    opacity: 1,
                  }
                }}
              >
                {clonedPagesHTML ? (
                  <div dangerouslySetInnerHTML={{ __html: clonedPagesHTML }} />
                ) : (
                  <div className="quick-print-live-render-surface">
                    {renderPrescriptionView({ showInUI: true })}
                  </div>
                )}
              </Box>
            </Box>
          </Drawer>
        </>
      )
    }
  },
)

PrescriptionMakingPage.displayName = 'PrescriptionMakingPage'

export default PrescriptionMakingPage
